// GENERATED by frontend/scripts/gen-tour-catalog.mjs from docs/tour/lessons.md.
// Do not edit by hand — edit the lesson list and run the script again.
import type { TourLesson, TourModule } from './tourTypes';

export const TOUR_MODULES: TourModule[] = [
  {
    "id": "M01",
    "title": "First day: sign in and set up the phone",
    "lessonIds": [
      "M01-L01",
      "M01-L02",
      "M01-L03",
      "M01-L04",
      "M01-L05",
      "M01-L06",
      "M01-L07",
      "M01-L08"
    ]
  },
  {
    "id": "M02",
    "title": "Your working day",
    "lessonIds": [
      "M02-L01",
      "M02-L02",
      "M02-L03",
      "M02-L04",
      "M02-L05",
      "M02-L06",
      "M02-L07",
      "M02-L08",
      "M02-L09",
      "M02-L10",
      "M02-L11",
      "M02-L12",
      "M02-L13"
    ]
  },
  {
    "id": "M03",
    "title": "Leads: find and read",
    "lessonIds": [
      "M03-L01",
      "M03-L02",
      "M03-L03",
      "M03-L04",
      "M03-L05",
      "M03-L06",
      "M03-L07",
      "M03-L08",
      "M03-L09",
      "M03-L10",
      "M03-L11",
      "M03-L12"
    ]
  },
  {
    "id": "M04",
    "title": "Leads: add and edit",
    "lessonIds": [
      "M04-L01",
      "M04-L02",
      "M04-L03",
      "M04-L04",
      "M04-L05",
      "M04-L06",
      "M04-L07",
      "M04-L08",
      "M04-L09",
      "M04-L10",
      "M04-L11",
      "M04-L12",
      "M04-L13",
      "M04-L14",
      "M04-L15",
      "M04-L16",
      "M04-L17",
      "M04-L18",
      "M04-L19",
      "M04-L20",
      "M04-L21",
      "M04-L22",
      "M04-L23"
    ]
  },
  {
    "id": "M05",
    "title": "Calls",
    "lessonIds": [
      "M05-L01",
      "M05-L02",
      "M05-L03",
      "M05-L04",
      "M05-L05",
      "M05-L06",
      "M05-L07",
      "M05-L08",
      "M05-L09",
      "M05-L10",
      "M05-L11",
      "M05-L12",
      "M05-L13",
      "M05-L14",
      "M05-L15",
      "M05-L16",
      "M05-L17"
    ]
  },
  {
    "id": "M06",
    "title": "Call wrap-ups and follow-ups",
    "lessonIds": [
      "M06-L01",
      "M06-L02",
      "M06-L03",
      "M06-L04",
      "M06-L05",
      "M06-L06",
      "M06-L07",
      "M06-L08",
      "M06-L09",
      "M06-L10",
      "M06-L11",
      "M06-L12"
    ]
  },
  {
    "id": "M07",
    "title": "How stages work: move, lose and reopen a lead",
    "lessonIds": [
      "M07-L01",
      "M07-L02",
      "M07-L03",
      "M07-L04",
      "M07-L05"
    ]
  },
  {
    "id": "M08",
    "title": "Selling: quotes (proposals) and calculators",
    "lessonIds": [
      "M08-L01",
      "M08-L02",
      "M08-L03",
      "M08-L04",
      "M08-L05",
      "M08-L06",
      "M08-L07",
      "M08-L08",
      "M08-L09",
      "M08-L10",
      "M08-L11",
      "M08-L12",
      "M08-L13",
      "M08-L14",
      "M08-L15",
      "M08-L16",
      "M08-L17",
      "M08-L18",
      "M08-L19",
      "M08-L20",
      "M08-L21"
    ]
  },
  {
    "id": "M09",
    "title": "Selling: sales orders and payment",
    "lessonIds": [
      "M09-L01",
      "M09-L02",
      "M09-L03",
      "M09-L04",
      "M09-L05",
      "M09-L06",
      "M09-L07",
      "M09-L08",
      "M09-L09",
      "M09-L10",
      "M09-L11",
      "M09-L12",
      "M09-L13",
      "M09-L14",
      "M09-L15",
      "M09-L16",
      "M09-L17",
      "M09-L18",
      "M09-L19",
      "M09-L20"
    ]
  },
  {
    "id": "M10",
    "title": "Discounts and approvals",
    "lessonIds": [
      "M10-L01",
      "M10-L02",
      "M10-L03",
      "M10-L04",
      "M10-L05",
      "M10-L06"
    ]
  },
  {
    "id": "M11",
    "title": "Dealers",
    "lessonIds": [
      "M11-L01",
      "M11-L02",
      "M11-L03",
      "M11-L04",
      "M11-L05",
      "M11-L06",
      "M11-L07",
      "M11-L08",
      "M11-L09",
      "M11-L10",
      "M11-L11",
      "M11-L12",
      "M11-L13",
      "M11-L14",
      "M11-L15",
      "M11-L16",
      "M11-L17",
      "M11-L18",
      "M11-L19",
      "M11-L20",
      "M11-L21",
      "M11-L22",
      "M11-L23",
      "M11-L24",
      "M11-L25",
      "M11-L26",
      "M11-L27",
      "M11-L28",
      "M11-L29",
      "M11-L30"
    ]
  },
  {
    "id": "M12",
    "title": "Field work",
    "lessonIds": [
      "M12-L01",
      "M12-L02",
      "M12-L03",
      "M12-L04",
      "M12-L05",
      "M12-L06",
      "M12-L07",
      "M12-L08",
      "M12-L09",
      "M12-L10",
      "M12-L11",
      "M12-L12"
    ]
  },
  {
    "id": "M13",
    "title": "Meetings, tasks and calendar",
    "lessonIds": [
      "M13-L01",
      "M13-L02",
      "M13-L03",
      "M13-L04",
      "M13-L05",
      "M13-L06"
    ]
  },
  {
    "id": "M14",
    "title": "Money and self-service",
    "lessonIds": [
      "M14-L01",
      "M14-L02",
      "M14-L03",
      "M14-L04",
      "M14-L05",
      "M14-L06",
      "M14-L07",
      "M14-L08",
      "M14-L09",
      "M14-L10",
      "M14-L11",
      "M14-L12",
      "M14-L13",
      "M14-L14",
      "M14-L15",
      "M14-L16",
      "M14-L17",
      "M14-L18"
    ]
  },
  {
    "id": "M15",
    "title": "Coordinator: working for your manager",
    "lessonIds": [
      "M15-L01",
      "M15-L02",
      "M15-L03",
      "M15-L04",
      "M15-L05"
    ]
  },
  {
    "id": "M16",
    "title": "Manager only (app)",
    "lessonIds": [
      "M16-L01",
      "M16-L02",
      "M16-L03",
      "M16-L04",
      "M16-L05",
      "M16-L06",
      "M16-L07",
      "M16-L08",
      "M16-L09",
      "M16-L10",
      "M16-L11",
      "M16-L12",
      "M16-L13",
      "M16-L14",
      "M16-L15",
      "M16-L16",
      "M16-L17"
    ]
  },
  {
    "id": "M17",
    "title": "Manager only (web)",
    "lessonIds": [
      "M17-L01",
      "M17-L02",
      "M17-L03",
      "M17-L04",
      "M17-L05",
      "M17-L06",
      "M17-L07",
      "M17-L08",
      "M17-L09",
      "M17-L10",
      "M17-L11",
      "M17-L12",
      "M17-L13",
      "M17-L14"
    ]
  },
  {
    "id": "M18",
    "title": "HR and admin (web)",
    "lessonIds": [
      "M18-L01",
      "M18-L02",
      "M18-L03",
      "M18-L04",
      "M18-L05",
      "M18-L06",
      "M18-L07",
      "M18-L08",
      "M18-L09",
      "M18-L10",
      "M18-L11",
      "M18-L12",
      "M18-L13",
      "M18-L14",
      "M18-L15",
      "M18-L16",
      "M18-L17"
    ]
  },
  {
    "id": "M19",
    "title": "Lead triage (web)",
    "lessonIds": [
      "M19-L01",
      "M19-L02",
      "M19-L03",
      "M19-L04",
      "M19-L05",
      "M19-L06",
      "M19-L07",
      "M19-L08",
      "M19-L09",
      "M19-L10",
      "M19-L11",
      "M19-L12",
      "M19-L13",
      "M19-L14"
    ]
  },
  {
    "id": "M20",
    "title": "Lead triage (Triage app)",
    "lessonIds": [
      "M20-L01",
      "M20-L02",
      "M20-L03",
      "M20-L04",
      "M20-L05",
      "M20-L06",
      "M20-L07",
      "M20-L08",
      "M20-L09",
      "M20-L10",
      "M20-L11"
    ]
  }
];

export const TOUR_LESSONS: TourLesson[] = [
  {
    "id": "M01-L01",
    "moduleId": "M01",
    "number": 1,
    "title": "Sign in to the app",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Type your work email in \"EMAIL\".",
      "Type your password in \"PASSWORD\". The eye icon shows it.",
      "Tap \"Sign in\".",
      "Red text under the fields tells you what went wrong.",
      "After sign-in the Setup & Permissions screen opens, not Home."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "runs before sign-in"
    }
  },
  {
    "id": "M01-L02",
    "moduleId": "M01",
    "number": 2,
    "title": "Set up calling and recording",
    "platform": "Android",
    "who": "Admin only — sets up a sales phone",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"Set up AURA calling & recording\" tap \"Set AURA as your phone app\".",
      "Allow \"Display over other apps\" and \"Caller ID & spam screening\".",
      "Allow \"Microphone + call audio\" and \"Phone (call detection)\".",
      "Allow \"Call recording access (All files)\" and \"Contacts (caller ID)\".",
      "Each card must show \"Granted\". \"Open Settings\" means you must change it in phone Settings.",
      "If you skipped it, the pre-call sheet shows \"AURA isn't your default phone app\" → \"Set as default\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L03",
    "moduleId": "M01",
    "number": 3,
    "title": "Set up location, camera and updates, then finish",
    "platform": "Android",
    "who": "Admin only — sets up a sales phone",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Location (background)\". Pick \"While using the app\" first.",
      "On the second prompt tap \"Change to allow all the time\".",
      "Allow \"Camera (field lead photos)\".",
      "Samsung only: open \"Battery whitelist (Samsung)\" and \"Auto-restart\".",
      "Tap \"Allow app updates\".",
      "If a report looks short of calls, tap \"Sync call logs\" → \"Sync now\".",
      "Tap \"Continue → Home\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L04",
    "moduleId": "M01",
    "number": 4,
    "title": "One-time setup on a Samsung Galaxy A07",
    "platform": "Android",
    "who": "Admin only — sets up a Samsung Galaxy A07 sales phone",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home find the banner \"Samsung Galaxy A07 detected\". Tap \"Run setup\".",
      "Card \"Disable battery optimization\" → \"Open Battery Settings\".",
      "Card \"Allow background activity\" → \"Open App Settings\". Set Battery to Unrestricted.",
      "Card \"Confirm \"Allow all the time\" location\" → \"Check Location Permission\".",
      "Tap \"All done — let's go!\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L05",
    "moduleId": "M01",
    "number": 5,
    "title": "Find your way around the app",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Read the sheet \"How AURA works\": Sprint, Disposition, Stage. Tap \"Got it\".",
      "Bottom bar: \"Home\", \"Leads\", the orange phone button, \"Follow-ups\", \"Quote\".",
      "Tap the top-left \"Menu\" icon for everything else. \"Team\" is in the menu, not in the bottom bar.",
      "Pull down on Home to refresh.",
      "Phone Back on any tab goes to Home. Back twice on Home leaves the app.",
      "The menu footer shows the app version and your name."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L06",
    "moduleId": "M01",
    "number": 6,
    "title": "Find your way around the web app",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Read the small heading at the top of the sidebar. It is your role menu.",
      "You can open only the pages in your own sidebar. Other links show \"No access\".",
      "Click \"Search\" (⌘K) and type in \"Search or jump to…\".",
      "Click the bell for \"Notifications\". Click a row to open it. \"Mark all read\" clears them.",
      "Click the round initials button for \"Profile\" and \"Logout\".",
      "Use the icon buttons for \"Dark mode\" and compact rows.",
      "On a narrow screen use the hamburger to open the sidebar."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L07",
    "moduleId": "M01",
    "number": 7,
    "title": "Forgot your password (app)",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the sign-in screen tap \"Forgot password?\" under \"PASSWORD\". It is there on \"Welcome to\" and on \"Welcome back\".",
      "On \"Reset your password\" check your work email in \"EMAIL\". If you typed it on the sign-in screen it is already filled in.",
      "Tap \"Send reset link\".",
      "\"Check your email\" opens. It says the same thing for every email, so it never tells anyone whether an account exists.",
      "Open the email \"Reset your AURA password\" and tap \"Reset password\". It opens in the browser. The link works for 30 minutes.",
      "Type the new password in \"New password\" and \"Confirm password\" (at least 8 characters). Tap \"Reset password\". Then sign in on the phone with the new password.",
      "No email? Wait until \"Resend in 1:00\" counts down, then tap \"Resend link\". Tap \"Back to sign in\" to go back. \"Too many reset requests. Please try again later.\" means wait 15 minutes."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "runs before sign-in"
    }
  },
  {
    "id": "M01-L08",
    "moduleId": "M01",
    "number": 8,
    "title": "Forgot your password (web)",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the web sign-in page click \"Forgot password?\" under \"Password\".",
      "On \"Reset your password\" type your work email in \"Email\". Click \"Send reset link\".",
      "The page says \"If an account exists for …, we've sent a reset link.\" It says this for every email.",
      "Open the email \"Reset your AURA password\" and click \"Reset password\". The link works for 30 minutes.",
      "Type the new password in \"New password\" and \"Confirm password\" (at least 8 characters). Click \"Reset password\".",
      "\"Your password has been reset. Redirecting to sign in…\" Sign in with the new password.",
      "\"Too many reset requests. Please try again later.\" means wait 15 minutes. \"Back to sign in\" goes back."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "runs before sign-in"
    }
  },
  {
    "id": "M02-L01",
    "moduleId": "M02",
    "number": 1,
    "title": "Start your day",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home find the punch card. Tap \"Start my day\".",
      "Location must be on, or you see \"Turn on location to punch in/out.\"",
      "Read the greeting pop-up and tap \"Go get 'em\".",
      "The card now shows \"On the clock since …\" and a timer.",
      "Tap the card to see calls and follow-ups so far. Tap \"Close\".",
      "Read the thought of the day strip. Tap it for the full message."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "starts the real day"
    }
  },
  {
    "id": "M02-L02",
    "moduleId": "M02",
    "number": 2,
    "title": "When the phone is not ready to start the day",
    "platform": "Android",
    "who": "Admin only — gets a sales phone ready for the day",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After \"Start my day\" the sheet \"Your phone is almost ready\" may open.",
      "Read the four checks: location on, \"Allow all the time\", battery saving off, internet.",
      "Tap \"Fix the N setting(s)\", fix them, then tap \"Start my day\" again.",
      "Or tap \"Start anyway\". Your km will be missing and TA/DA lower. Your manager sees it.",
      "If you swipe the sheet away the day does NOT start."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "starts the real day"
    }
  },
  {
    "id": "M02-L03",
    "moduleId": "M02",
    "number": 3,
    "title": "Fix \"Your location is not being recorded\"",
    "platform": "Android",
    "who": "Admin only — fixes location recording on a sales phone",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home find the red card \"Your location is not being recorded\". Tap \"Turn it back on\".",
      "Pick \"My phone is Samsung\" or \"My phone is Xiaomi / Oppo / Vivo\".",
      "Follow the steps: Location = \"Allow all the time\", Battery = \"Unrestricted\".",
      "Tap \"Allow unrestricted battery\" or \"Open that settings screen\".",
      "Xiaomi / Oppo / Vivo: set Autostart by hand. The app cannot check it.",
      "Low battery card: AURA stops GPS below 15% and starts again above 15%. Tap \"Got it\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L04",
    "moduleId": "M02",
    "number": 4,
    "title": "Wrap up your day",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the punch card tap \"Wrap up my day\".",
      "Before shift end the pop-up \"Wrapping up early?\" opens. Pick \"Half day\", \"Personal\", \"Unwell\" or \"Other\".",
      "Tap \"Wrap up my day\", or \"Stay on the clock\" to keep working.",
      "Read the \"Day-End Summary\": calls, talk time, follow-ups done, won today.",
      "Tap \"Download PDF\" to save or share it.",
      "The card now reads \"Day wrapped\". You cannot start again until tomorrow."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "ends the real day"
    }
  },
  {
    "id": "M02-L05",
    "moduleId": "M02",
    "number": 5,
    "title": "Answer \"Still working?\" after shift end",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After shift end a card \"Still working?\" shows above the punch card.",
      "Tap \"Still on the road\". It asks again after 30 minutes.",
      "Or tap \"I'm done\" to end the day.",
      "From 11:30 pm the card warns that AURA closes your day at 12:00 am."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "ends the real day"
    }
  },
  {
    "id": "M02-L06",
    "moduleId": "M02",
    "number": 6,
    "title": "Check your attendance for the month",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "While the day is open, tap the timer chip on the punch card.",
      "\"Attendance history\" opens. Use the arrows to change month.",
      "Read \"Total hours\", \"Days present\", \"Avg / day\".",
      "Green bar = target met. Amber = below target. Absent days are not listed.",
      "Tap the ⓘ chip to read why the office adjusted a day."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L07",
    "moduleId": "M02",
    "number": 7,
    "title": "Read your target and quota on Home",
    "platform": "Android",
    "who": "All sales (target card only when a target is set)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home find the target card. Read \"Ahead\", \"On track\" or \"Behind pace\".",
      "Switch \"Units\" / \"₹\".",
      "Tap \"Steps to achieve your target\" and read \"Gap by product\" and \"Recommended actions\".",
      "Tap \"Start today's calls\".",
      "Read the quota ring \"Quota this month\" (counted from the 1st). A product with no number reads \"Not set up\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L08",
    "moduleId": "M02",
    "number": 8,
    "title": "Read your pipeline and performance on Home",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Scroll Home to \"Your pipeline\". Tap \"HIGH\", \"MEDIUM\" or \"LOW\" to jump to Leads.",
      "Tap a stage chip to jump to that stage.",
      "In the performance block switch \"DAILY\", \"WEEKLY\", \"MONTHLY\".",
      "Read \"Calls\", \"Connected\", \"Leads added\", \"Followups done\" (done / due). MONTHLY counts from the 1st.",
      "On DAILY also read \"Talk today\" and \"Not connected\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L09",
    "moduleId": "M02",
    "number": 9,
    "title": "Read and clear your notifications",
    "platform": "Android",
    "who": "All sales (\"Approvals\" tab for managers)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap the bell. The screen \"Activity\" opens.",
      "Use the tabs \"All\" and \"Hot\".",
      "Tap an alert to open the lead or approval. Alerts tagged \"Info\" open nothing.",
      "Tap the tick to mark one read, or \"Mark all read\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L10",
    "moduleId": "M02",
    "number": 10,
    "title": "Set your notification sounds",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Notification Sounds\".",
      "For \"HOT\", \"WARM\", \"COLD\" turn the switch on or off and pick a sound. Tap \"Preview\".",
      "Set \"Quiet hours\". HOT always rings.",
      "Set \"Vibrate\" and \"Per-event alerts\".",
      "Tap \"Save\". Nothing is kept until you do."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M02-L11",
    "moduleId": "M02",
    "number": 11,
    "title": "Work without network: the offline queue",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "With no signal the app saves on the phone and says \"will sync\".",
      "On Home a banner shows \"N action(s) queued\". Tap \"Retry\".",
      "Profile → \"Offline queue\" shows what is waiting.",
      "A row with \"Conflict\" opens \"Keep mine\" / \"Keep server\" / \"Keep mine & merge note\" / \"Decide later\".",
      "A red message at the bottom means the server refused a saved lead or call outcome."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L12",
    "moduleId": "M02",
    "number": 12,
    "title": "Punch in and out on the web",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click the round initials button.",
      "Click \"Punch In\". Allow location in the browser.",
      "At the end of the day click \"Punch Out\".",
      "\"Location needed to punch — allow location access\" means the browser blocked location."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "real punch"
    }
  },
  {
    "id": "M02-L13",
    "moduleId": "M02",
    "number": 13,
    "title": "Use the \"My Day\" dashboard on the web",
    "platform": "Web",
    "who": "P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Dashboard\". The heading is \"My Day\".",
      "Click a number card: \"Calls today\", \"Follow-ups due\", \"Open proposals\", \"Won this month\", \"My outstanding\".",
      "\"Follow-ups due\" counts the follow-ups due by tonight. Its \"overdue\" number is the same as on the Follow-ups page.",
      "In \"Call queue\" click \"Call\" on a row.",
      "Read \"Today\" for calls, follow-ups and meetings in time order.",
      "Read \"My proposals\" and \"My outstanding\". Click \"View all\" for the full list.",
      "Use \"Add lead\" and \"Quick Quote\" at the top."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L01",
    "moduleId": "M03",
    "number": 1,
    "title": "Open the Leads screen and read the stage boxes",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Leads\" in the bottom bar.",
      "Read \"Sales Pipeline · N total\".",
      "Tap a stage header to open it: \"New\", \"Follow-up\", \"Closing\", \"Quoted\", \"Negotiation\", \"Won\", \"Lost\".",
      "Tap a row to open the lead. Tap the green phone to call.",
      "Switch \"Kanban view\" / \"List view\" with the header toggle.",
      "Pull down to refresh."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L02",
    "moduleId": "M03",
    "number": 2,
    "title": "Read a lead row",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Read the name and the stage chip.",
      "Read the \"HOT\" / \"WARM\" / \"COLD\" pill with the score.",
      "Look for \"REPEAT\", \"PAYMENT PENDING\", \"DISCOUNT PENDING\".",
      "Alarm chip: wine = overdue, saffron = today, green = later.",
      "\"Follow-up #N of M\" means follow-ups were missed.",
      "A wine chip next to \"LOST\" gives the lost reason."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L03",
    "moduleId": "M03",
    "number": 3,
    "title": "Look up a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap the search bar. Or on Leads use \"Search name, company, phone...\".",
      "Type a name, company or phone. A phone search needs at least 4 digits.",
      "Results come as one list across all stages.",
      "Tap a row to open the lead.",
      "With dealer access, use the chips \"All\" / \"Leads\" / \"Dealers\".",
      "You only see leads you are allowed to see."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L04",
    "moduleId": "M03",
    "number": 4,
    "title": "Filter and sort your leads",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads tap the sliders icon. The sheet \"Filter Leads\" opens.",
      "Pick a \"STAGE\" chip, \"High Priority\" or \"Overdue Only\". Tap \"Apply\".",
      "\"DATE\", \"SOURCE\", \"Location\" and \"Product\" apply at once.",
      "Remove a filter with ✕ on its pill, or \"Clear all\".",
      "Tap the up/down arrows for \"SORT LEADS\" and pick an order."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L05",
    "moduleId": "M03",
    "number": 5,
    "title": "Work your newly assigned leads",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home find \"RECENTLY ASSIGNED\". Tap \"View all\".",
      "The \"Assignment queue\" opens. Pick \"Today\", \"5 days\" or \"All\".",
      "A HOT lead shows a timer. Green = time left. Amber = last 30 minutes. Red = overdue.",
      "Tap a row to open the lead and call.",
      "Use the sort chip: \"Newest assigned\" or \"Most urgent\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L06",
    "moduleId": "M03",
    "number": 6,
    "title": "Open a lead and read its page",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap a lead. Read the name, company and place.",
      "Read the three chips under \"LEAD DETAILS\". They change by stage.",
      "Tap a row to open a section: \"Overview\", \"Activities\", \"Files & quotes\", \"Meetings\", \"Sales orders\", \"Approvals\", \"All calls\".",
      "In \"Overview\" read \"REQUIREMENT\", \"CONTACTS\" and the details grid.",
      "Bottom bar: \"Call\" is the main button on New and Follow-up. \"Proposal\" is the main button on Quoted, Negotiation and Prospect.",
      "Tap the WhatsApp icon to open a chat."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L07",
    "moduleId": "M03",
    "number": 7,
    "title": "Set when the customer needs the product (temperature)",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Set requirement window\".",
      "Pick \"Within 7 Days\", \"Within 30 Days\", \"Within 90 Days\" or \"90–180 Days\".",
      "The \"Temperature\" banner turns HOT, WARM or COLD.",
      "Read the chase warning strip, for example \"Hot — window closing, chase now\".",
      "To set it by hand open \"Override temperature\". \"Revert to auto (bucket-derived)\" undoes it.",
      "Read the \"Lead score\" banner."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "picking a window"
    }
  },
  {
    "id": "M03-L08",
    "moduleId": "M03",
    "number": 8,
    "title": "Read what the customer already told us",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"Responses & details\".",
      "Read the answers: \"Application\", \"Capacity\", \"Price shared\", \"Quantity\".",
      "On a B2B lead read \"DEALER / B2B\".",
      "Read \"WHATSAPP TRANSCRIPT\".",
      "Read \"WHY THIS SCORE\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L09",
    "moduleId": "M03",
    "number": 9,
    "title": "See which leads are still waiting on you (Lead Activity)",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Lead Activity\".",
      "Tap the date bar and pick a day or a range.",
      "Use the chips \"Assigned to me\", \"I added\", \"Field\".",
      "Tap \"Not actioned\" to see leads you have not worked.",
      "Read the colour band: green, amber, red.",
      "Tap a row to open the lead."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L10",
    "moduleId": "M03",
    "number": 10,
    "title": "Look up a lead on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Leads\" (or \"My Leads\"). The heading is \"Sales Pipeline\".",
      "Type in \"Search by name, email, company, phone...\".",
      "Click a stage tab: \"All\", \"Cold\", \"Follow-up\", \"Quote Shared\", \"Negotiation\", \"Prospect\", \"Won\", \"Lost\".",
      "Click \"Filters\" for priority, \"Lost Reason\", \"Source:\", date and type.",
      "Click \"Clear\" to remove filters.",
      "Switch \"List\" / \"Board\" at the top."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L11",
    "moduleId": "M03",
    "number": 11,
    "title": "Read a lead on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the list read the columns: Stage, Score, Assigned, Follow-up.",
      "A red date in Follow-up means overdue.",
      "Click a row. The detail panel opens.",
      "Read \"Pipeline Stage\". You cannot change it by hand.",
      "Set \"Priority\" and \"Interest Level\" if needed.",
      "Read \"Product & Requirement\", \"Field Photos\" and \"Interaction History\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L12",
    "moduleId": "M03",
    "number": 12,
    "title": "See leads waiting on you on the web (Lead Activity)",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Lead Activity\" under \"My Work\".",
      "Set \"From\" and \"To\", or click \"Today\".",
      "Click \"Not actioned N\".",
      "Read the colour band: green \"On time\", amber, red.",
      "Click a row. The lead page opens with call and \"WhatsApp\" buttons.",
      "Click \"Back to leads\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M04-L01",
    "moduleId": "M04",
    "number": 1,
    "title": "Add a Normal Lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap \"Add Lead\". Pick \"Normal Lead\".",
      "Type the \"MOBILE\". Tap \"Check number\".",
      "Fill \"FULL NAME\". Add \"COMPANY\" and \"GSTIN\" if any. \"Fetch\" fills from GST.",
      "Type the \"PINCODE\". State and city fill in.",
      "Pick \"CUSTOMER TYPE\": \"B2C\", \"B2B\" or \"Project\".",
      "Tap \"Save lead\". The lead shows after it syncs."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save lead\""
    }
  },
  {
    "id": "M04-L02",
    "moduleId": "M04",
    "number": 2,
    "title": "Fill the inquiry, photos and references on a new lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In \"INQUIRY\" pick \"PRODUCT INTEREST\".",
      "Set \"DECISION MAKER?\", \"BUDGET\" and \"TIMELINE\".",
      "Add up to 3 photos in \"PHOTOS (OPTIONAL)\".",
      "In \"REFERENCES (OPTIONAL)\" tap \"Add reference\" and pick the \"Type\".",
      "Fill \"Name\" and \"Phone (10 digits)\". For a dealer tap \"Pick a dealer\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save lead\""
    }
  },
  {
    "id": "M04-L03",
    "moduleId": "M04",
    "number": 3,
    "title": "When the number already exists: open it or request access",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After the number check you may see \"This lead is already yours\". Tap \"Open it\".",
      "Or you see \"Number already exists\". Tap \"Request access\".",
      "The same happens in Quick Quote and Quick Sale.",
      "Menu → \"Access Requests\" shows \"Pending\", \"Approved\", \"Declined\".",
      "Approval moves the lead to you."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Request access\""
    }
  },
  {
    "id": "M04-L04",
    "moduleId": "M04",
    "number": 4,
    "title": "Add a lead that a dealer will fulfil",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the Normal Lead form set \"FULFILLED BY\" to \"Dealer\".",
      "Tap \"DEALER\" → \"Select dealer…\".",
      "Or tap \"+ Add a new dealer\".",
      "If the dealer misses bank details, phone or pincode, Save asks for them.",
      "Without a dealer the lead does not save."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save lead\""
    }
  },
  {
    "id": "M04-L05",
    "moduleId": "M04",
    "number": 5,
    "title": "Add a lead after a call with an unknown number",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After the call the sheet \"Call ended\" opens.",
      "Tap \"Add as Lead\". The number is already filled.",
      "Or tap \"Save to AURA\", pick \"Who is this?\" and tap \"Save\".",
      "Or tap \"Save to phone only\", or \"Not now\".",
      "You can also tap \"+ Lead\" on a recent call, \"Add Lead\" in the Call Log or on the Caller screen, and \"Add lead\" during a call."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M04-L06",
    "moduleId": "M04",
    "number": 6,
    "title": "After a call with a plumber, dealer or partner: log the lead they referred",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After the call Wrap Up shows a party card with the name and a badge.",
      "For an AURA contact fix the type under \"Who is this? (updates the contact)\".",
      "Tap \"+ Log referred lead\".",
      "The New Lead form opens with this caller filled as the reference.",
      "Finish the lead, then finish the wrap-up."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M04-L07",
    "moduleId": "M04",
    "number": 7,
    "title": "Edit a lead's details",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"Overview\". Tap \"Edit\" beside \"LEAD DETAILS\".",
      "\"FULL NAME\" and \"MOBILE\" are locked. Only an admin can change them.",
      "Change \"COMPANY\", \"ADDRESS\", \"STATE\", \"CITY\", \"BUDGET\", \"TIMELINE\", \"REQUIREMENT\".",
      "A saved \"PINCODE\" needs \"Edit\" and a written reason.",
      "Tap \"Save\".",
      "To add a product tap \"+ Add\" under \"PRODUCTS\". Products cannot be removed."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M04-L08",
    "moduleId": "M04",
    "number": 8,
    "title": "Add another contact person to a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead → \"Edit\" → \"CONTACTS\".",
      "Tap \"Add contact\". Fill \"NAME\", \"PHONE\", \"ROLE (optional)\".",
      "Tap \"Add contact\".",
      "Tap \"Make primary\" to call this person first.",
      "The bin icon removes an added contact. The first contact can never be removed."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add contact\""
    }
  },
  {
    "id": "M04-L09",
    "moduleId": "M04",
    "number": 9,
    "title": "Add a reference to a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead → \"Edit\" → \"REFERENCES\" → \"Add reference\".",
      "Pick the \"Type\": \"Plumber\", \"Architect\", \"Dealer\", \"Affiliate\", \"Existing customer\".",
      "If asked, save the lead pincode first.",
      "Search the person, or tap \"Add new\" and fill \"Name\" and \"Phone (10 digits)\".",
      "Tap \"Attach\". ✕ removes a reference."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Attach\""
    }
  },
  {
    "id": "M04-L10",
    "moduleId": "M04",
    "number": 10,
    "title": "Add photos and a GPS location to a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"Overview\" → \"FIELD PHOTO\" → \"Add photo\".",
      "Pick \"Camera (field-stamped)\" or a Gallery option. Maximum 6 photos.",
      "Tap a thumbnail to view, \"Replace\" or \"Delete\".",
      "Under \"LOCATION\" tap \"Add location\".",
      "If you see \"Location is approximate\" tap \"Retake\" or \"Use anyway\".",
      "Tap \"Open in Maps\" to check."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a photo and GPS"
    }
  },
  {
    "id": "M04-L11",
    "moduleId": "M04",
    "number": 11,
    "title": "Add a note to a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"Activities\".",
      "Tap \"Add note\".",
      "Write the note and tap \"Save\".",
      "With no network the note is queued and syncs later."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M04-L12",
    "moduleId": "M04",
    "number": 12,
    "title": "Use your phone contacts with leads",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Contacts\". Allow contacts access.",
      "Rows tagged \"ALREADY A LEAD\" are leads.",
      "Search with \"Search by name or phone\".",
      "Tap a row: \"Call\", \"Open lead\", \"Save lead → device contact\", or \"Save device contact → lead\".",
      "\"Add\" saves a new number to the phone only."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M04-L13",
    "moduleId": "M04",
    "number": 13,
    "title": "Call several contacts one after another (calling queue)",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Contacts tap \"Select\" and tick the rows.",
      "Tap \"Call N contacts\".",
      "On the Calling Queue tap \"Call now\".",
      "After the call tap \"Next contact\". The queue never moves by itself.",
      "Tap \"Add as lead\" or \"Open lead\" for the current contact.",
      "Tap \"Stop\" to end. The bin deletes selected contacts from the phone."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "real calls"
    }
  },
  {
    "id": "M04-L14",
    "moduleId": "M04",
    "number": 14,
    "title": "Start a repeat order for a past customer",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"My Customers\".",
      "Tap \"Reactivate\" on the customer.",
      "A NEW lead opens. The old won deal stays as it is.",
      "In Quick Quote a won customer shows \"Past customer — won\". Tap \"Start repeat quote\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Reactivate\""
    }
  },
  {
    "id": "M04-L15",
    "moduleId": "M04",
    "number": 15,
    "title": "Escalate a lead to your manager and track transfers",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Escalate to manager\". Add a reason. Tap \"Escalate\".",
      "Menu → \"Transfers\". \"Inbox\" = sent to you. \"Outbox\" = sent by you.",
      "In Inbox tap \"Acknowledge\", then later \"Mark done\".",
      "A chip such as \"Escalated → name\" shows on the lead row and the lead page.",
      "Home shows the card \"Team assignments\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Escalate\""
    }
  },
  {
    "id": "M04-L16",
    "moduleId": "M04",
    "number": 16,
    "title": "Add a lead on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads click \"Add Lead\".",
      "Fill \"Name *\" and \"Phone\". Pick \"Product Interest *\".",
      "Type the \"Pincode\". The location fills in.",
      "Set \"Priority\" and \"Interest Level\".",
      "Add a person under \"References (Optional)\" if any.",
      "Click \"Add Lead\". If the number exists you are asked to open the existing lead."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add Lead\""
    }
  },
  {
    "id": "M04-L17",
    "moduleId": "M04",
    "number": 17,
    "title": "Import leads from a CSV or Excel file on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads click \"Import\".",
      "In \"CSV / Excel Import\" click \"Download sample\", or use your own file. Columns like Name, Mobile or Contact, City or Address work. Every lead needs a phone.",
      "Click \"Upload CSV / Excel\" and pick a .csv or .xlsx file. Nothing is saved yet.",
      "Check where each column goes, and how many rows will import or are skipped (no phone).",
      "Click \"Import\". The new leads are assigned to you. A phone already in AURA is not added again.",
      "\"Sources\" shows the configured lead sources, read only. Only an admin can add, switch off or delete a source. Ask your admin."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Upload CSV / Excel\""
    }
  },
  {
    "id": "M04-L18",
    "moduleId": "M04",
    "number": 18,
    "title": "Process new leads on the web: convert or reject",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Only leads with status \"new\" have a checkbox.",
      "Click \"Convert\" on a row to make it a contact.",
      "Click ✕ (\"Reject\") to reject it.",
      "Tick several rows and click \"Process Selected (N)\".",
      "In the panel use \"Convert to Contact\", then \"View Contact\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Convert\""
    }
  },
  {
    "id": "M04-L19",
    "moduleId": "M04",
    "number": 19,
    "title": "Keep a lead up to date on the web: notes, follow-up date, details",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead panel.",
      "Set the \"Follow-up Date\".",
      "Click \"Capture\" and fill \"Interest *\", \"Product Requirement *\", \"Requirement Details *\".",
      "Write in \"Notes\" and click \"Save Notes\".",
      "Click \"Log Activity\", pick the \"Activity Type\", fill \"Title *\", click \"Save Activity\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each save"
    }
  },
  {
    "id": "M04-L20",
    "moduleId": "M04",
    "number": 20,
    "title": "Check that a lead's phone and email work, on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the panel find \"WhatsApp / Phone Status\".",
      "Click \"Valid\", \"Not Active\" or \"Incorrect\".",
      "Click \"WhatsApp Verify\" to send a check message.",
      "Click \"Send Verification Email\", or \"Request Email\" if there is none."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M04-L21",
    "moduleId": "M04",
    "number": 21,
    "title": "Find and read a contact on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Contacts\". Read the four tiles.",
      "Type in \"Search contacts...\" and use the filters.",
      "Click a header to sort.",
      "Click a row. Read the tabs \"Overview\", \"Activities\", \"Deals\", \"Invoices\".",
      "Click the phone link to call."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M04-L22",
    "moduleId": "M04",
    "number": 22,
    "title": "Add, edit or import contacts on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click \"Add Contact\". Fill \"First Name *\", \"Last Name *\", \"Email *\". Click \"Create Contact\".",
      "Click the edit action on a row. Change fields. Click \"Save Changes\".",
      "Click \"Import CSV\" → \"Upload CSV File\" and check the preview.",
      "Delete asks you to confirm."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create Contact\""
    }
  },
  {
    "id": "M04-L23",
    "moduleId": "M04",
    "number": 23,
    "title": "Log an activity or send a WhatsApp from a contact on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open a contact.",
      "Click \"Add Activity\". Pick \"Type\". Fill \"Description *\". Click \"Add Activity\".",
      "Click \"Send WhatsApp\". Fill \"Message *\". Click \"Send Message\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M05-L01",
    "moduleId": "M05",
    "number": 1,
    "title": "Call a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap the green phone on a lead row, or \"Call\" on the lead page.",
      "Read the pre-call brief: owner, last contact, product, last proposal.",
      "Tap \"Call Now\".",
      "If the lead has two or more numbers, pick one in \"Which number?\".",
      "\"WhatsApp\" opens a chat instead. \"Follow-up\" opens the lead.",
      "After the wrap-up, the brief for the next lead in the list opens by itself."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Call Now\""
    }
  },
  {
    "id": "M05-L02",
    "moduleId": "M05",
    "number": 2,
    "title": "Dial any number from the keypad",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap the orange phone button. Call Hub opens.",
      "Tap \"Keypad\" and type the number. Long-press 0 for \"+\".",
      "Tap the centre phone button to dial. With nothing typed it redials the last number.",
      "\"RECENTS\" shows recent calls. Tap the phone icon to call back.",
      "Tap a row body to open the caller card.",
      "\"Hide keypad\" shows the full list."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "dialling"
    }
  },
  {
    "id": "M05-L03",
    "moduleId": "M05",
    "number": 3,
    "title": "Answer an incoming call",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "The screen shows \"INCOMING CALL · AURA MATCHED\" for a known lead.",
      "Read the brief before you answer.",
      "Tap \"Answer\" or \"Decline\".",
      "An unknown number shows \"UNKNOWN — No matching lead for this number.\""
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M05-L04",
    "moduleId": "M05",
    "number": 4,
    "title": "Use the call screen: mute, speaker, hold, minimise, end",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "While it rings read \"CALLING · VIA AURA\". \"Cancel call\" stops it with no wrap-up.",
      "In the call use \"Mute\", \"Speaker\", \"Hold\".",
      "Tap the down-arrow to shrink the call to a floating pill. The call keeps running.",
      "Tap the pill to come back. The pill also has mute and end.",
      "Tap \"End\". Wrap Up opens.",
      "If the phone's own dialer took over, tap \"Hung up? Tap to wrap up\".",
      "A second caller shows a banner. Tap \"Decline\"."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M05-L05",
    "moduleId": "M05",
    "number": 5,
    "title": "Use the in-call tools: note, lead, calculator, quote, competitor",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Note\", write up to 280 characters, tap \"Save to call log\".",
      "Tap \"Lead\" to open the lead page.",
      "Tap \"Calc\" or the \"Calculators\" bar to size a product.",
      "Tap the chip \"Sample Quote\" or \"Discount request\".",
      "Tap \"Competitor mention\", pick the competitor, tap \"Save mention\".",
      "\"Keypad\" is only a notepad for digits. It does not send tones."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M05-L06",
    "moduleId": "M05",
    "number": 6,
    "title": "Add a teammate to a call",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the call tap \"Add\".",
      "In \"Add a teammate\" search the staff list and tap a name.",
      "Or tap \"Type a number to add manually\" and dial.",
      "The banner reads \"Customer on hold · name on the line\".",
      "The two calls are not merged. When the teammate hangs up, the customer call continues."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M05-L07",
    "moduleId": "M05",
    "number": 7,
    "title": "Sprint: pick a list and start",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap the orange phone button → \"Sprint\".",
      "Read \"N leads ready\".",
      "Tap the list button and pick a list, for example \"Follow-ups due\" or \"Fresh leads\". A list with 0 leads is greyed.",
      "Read \"UP NEXT\".",
      "Tap \"Start Sprint\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Start Sprint\""
    }
  },
  {
    "id": "M05-L08",
    "moduleId": "M05",
    "number": 8,
    "title": "Sprint: run through the queue",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Each lead gets a 3-second countdown. Then the pre-call sheet opens. Tap \"Call Now\".",
      "Use \"Pause\", \"Resume\", \"Skip\".",
      "After \"Save & Next\" the sprint moves to the next lead.",
      "A card \"LOCKED\" shows why a lead cannot be called. Tap \"Skip\".",
      "Change the order with \"Priority\" / \"Newest\" / \"Oldest\".",
      "Tap \"Stop\" to end, or \"Complete Sprint\" on the last lead."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "dials real leads"
    }
  },
  {
    "id": "M05-L09",
    "moduleId": "M05",
    "number": 9,
    "title": "Read your call log",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap the chip \"N calls today\".",
      "Filter with \"All\", \"Incoming\", \"Outgoing\", \"Missed\", \"Rejected\", \"Unknown\".",
      "Tap \"Redial\", or the chip \"Needs Call Back\" on a missed call.",
      "Tap \"View transcript\".",
      "\"queued\" means the call is not yet sent to the server.",
      "Tap \"Save Contact\" to save a caller to the phone."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M05-L10",
    "moduleId": "M05",
    "number": 10,
    "title": "Open a caller's card, recording and transcript",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the Call Log tap a row. The screen \"Caller\" opens.",
      "Read the stage, last outcome and next follow-up.",
      "\"Owned by name — view only\" means the lead is someone else's.",
      "Under \"CALL HISTORY\" tap a call.",
      "Play the \"RECORDING\" and read the \"TRANSCRIPT\".",
      "Tap \"Copy\" or \"Re-transcribe\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M05-L11",
    "moduleId": "M05",
    "number": 11,
    "title": "Listen to past calls on a lead",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"All calls\" or \"Recent calls\".",
      "Tap \"Play\" to hear a recording.",
      "Tap a call row to open it.",
      "Tap \"Edit\" to change the notes of a call, then \"Save\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M05-L12",
    "moduleId": "M05",
    "number": 12,
    "title": "Log a call you made outside the app",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap the icon \"Log past call\".",
      "Pick \"Direction\", \"Duration\" and \"When did this happen?\".",
      "Add a \"Voice note (optional)\". It can be up to 60 seconds.",
      "Tap \"Set call outcome\" and pick \"Connected\", \"No Answer\" or \"Busy / Call back\".",
      "Tap \"Log call\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Log call\""
    }
  },
  {
    "id": "M05-L13",
    "moduleId": "M05",
    "number": 13,
    "title": "What to do when a call is not recorded",
    "platform": "Android",
    "who": "Admin only — fixes call recording on a sales phone",
    "managerOnly": false,
    "adminOnly": true,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Recording is automatic. There is no record button.",
      "A red banner in the call says why recording failed. Tap it.",
      "On \"Recording diagnostics\" tap \"Test recording (3s)\".",
      "\"RECORD_AUDIO granted: NO\" means the mic permission is off. Turn it on.",
      "Tap \"Share trace\" and send it to support."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M05-L14",
    "moduleId": "M05",
    "number": 14,
    "title": "Send a WhatsApp message from a template",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Settings\" → \"AI WhatsApp\".",
      "Type the \"PHONE NUMBER\".",
      "Pick \"Greeting\", \"Follow-up\" or \"Quote follow-up\".",
      "Edit \"YOUR MESSAGE\" and tap \"Open WhatsApp\".",
      "AI drafting is not live yet. You write the message."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Open WhatsApp\""
    }
  },
  {
    "id": "M05-L15",
    "moduleId": "M05",
    "number": 15,
    "title": "Go \"Available\" for calls on the web and use the call bar",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "First save your number in Profile → \"Call Routing\" → \"Dial-able mobile number\" → \"Save Number\".",
      "In the top bar click the chip \"Unavailable\". It turns \"Available\".",
      "\"On call\" cannot be clicked.",
      "In the bottom call bar type a number and click \"Dial\". It reads \"Opens your phone to call\": the call is made on your phone.",
      "Click \"Next from queue\" to call the next lead. It also opens your phone.",
      "Talk and end the call on your phone. The web has no \"Hang up\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "changes live availability"
    }
  },
  {
    "id": "M05-L16",
    "moduleId": "M05",
    "number": 16,
    "title": "Call a lead from the web and record what happened",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead panel. Click \"Call Now\".",
      "After the call fill the form \"Call Outcome\" and \"Notes\". Click \"Save & Update\".",
      "To log a call made elsewhere click \"Log Call\", pick the \"Outcome\", click \"Save Call\".",
      "\"WhatsApp\" opens a chat.",
      "To call from your phone click \"Push to AURA Sales App\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M05-L17",
    "moduleId": "M05",
    "number": 17,
    "title": "Work your Call Queue on the web",
    "platform": "Web",
    "who": "P02 (coordinator)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Call Queue\".",
      "Your earliest follow-ups come first.",
      "Type in \"Search your queue\".",
      "Click \"Call\" on a row.",
      "Click \"Refresh\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Call\""
    }
  },
  {
    "id": "M06-L01",
    "moduleId": "M06",
    "number": 1,
    "title": "Wrap up a connected call",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After the call the screen \"Wrap Up\" opens.",
      "Under \"How did it go?\" keep \"Connected\".",
      "Tap one outcome tile, for example \"Call back\".",
      "Write what was said in \"Quick notes…\".",
      "Tap \"Save & Next\".",
      "X leaves without saving."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M06-L02",
    "moduleId": "M06",
    "number": 2,
    "title": "Wrap up a call that did not connect",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Wrap Up switch to \"Not connected\".",
      "Tap \"Ringed, no answer\", \"Busy\", \"Switched off\" or \"Try later\".",
      "The stage does not change. A follow-up is set by itself.",
      "Tap \"Retry now\" to save and dial the same number again.",
      "Or tap \"Save & Next\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M06-L03",
    "moduleId": "M06",
    "number": 3,
    "title": "Set the next follow-up on the wrap-up",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Wrap Up tap \"Schedule follow-up\".",
      "Pick the date, then the time.",
      "Read the bold row. It says \"Follow-up ✓ …\" or \"No follow-up set\".",
      "\"Set by you\" or \"Set by disposition\" tells you who set it.",
      "A date is sent only if you really pick one."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M06-L04",
    "moduleId": "M06",
    "number": 4,
    "title": "Wrap up when the customer says no, or the number is wrong",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Connected: tap \"Not interested\" or \"Irrelevant Lead – Out of Budget\".",
      "Not connected: tap \"Wrong number\" or \"Do not call\".",
      "The sheet \"Why was this lead lost?\" opens. Pick a reason.",
      "\"Lost to competitor\" needs the competitor. \"Other\" needs a typed reason.",
      "Tap \"Mark as Lost\", then \"Save & Next\".",
      "The lead becomes Lost. These tiles are hidden on a Won or Lost lead."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M06-L05",
    "moduleId": "M06",
    "number": 5,
    "title": "Tell the app the deal is in negotiation or close to buying",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a Quoted lead, connected call, tap \"Negotiating — discussing price/terms\".",
      "On a Quoted or Negotiation lead tap \"Prospect — confident to close\".",
      "You can pick only one of the two.",
      "There is no \"Won\" tile. The banner says \"Won unlocks after Accounts confirms payment.\"",
      "On a Won or Lost lead the banner says outcomes will not move it."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M06-L06",
    "moduleId": "M06",
    "number": 6,
    "title": "Rules: what each wrap-up outcome does",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "\"Meeting set\" and \"Call back\": a New lead moves to Follow-up. A follow-up is set.",
      "\"Not interested\", \"Wrong number\", \"Do not call\": the lead becomes Lost.",
      "No answer, busy, switched off, try later: no stage change. A follow-up is set.",
      "\"Create Quote\", \"Revise Proposal\" and \"Prospect dealer\" are actions, not outcomes. You must still pick an outcome and tap \"Save & Next\".",
      "You never pick the stage. The server works it out.",
      "After a call: lead → Wrap Up. Unknown number → \"Call ended\". Active dealer → no screen."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M06-L07",
    "moduleId": "M06",
    "number": 7,
    "title": "Edit your last wrap-up",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead. Find the card \"LAST WRAP-UP\".",
      "Tap \"Edit wrap-up\".",
      "Change the connected toggle, the outcome, the notes or the stage declaration.",
      "Tap \"Save & Next\". You see \"Wrap-up updated.\"",
      "Only the lead's LAST call can be edited, and never on a Won lead.",
      "Changing a wrong \"Not interested\" to \"Call back\" brings a Lost lead back."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save & Next\""
    }
  },
  {
    "id": "M06-L08",
    "moduleId": "M06",
    "number": 8,
    "title": "Work your follow-ups list",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Follow-ups\" in the bottom bar. Switch \"All\", \"Today\", \"Upcoming\" (next 7 days), \"Long-term\".",
      "The top line reads \"X scheduled · Y overdue · Z need a date\".",
      "Late follow-ups come first under \"OVERDUE\", in red, with the day they were due, for example \"5 Oct · OVERDUE\".",
      "The rest are under \"TODAY\", \"TOMORROW\" and \"LATER\". A lead you have already won keeps its follow-up with a green \"WON\" tag.",
      "Tap \"Call\" to call, or tap the row to open the lead. When the follow-up is finished, tap \"Done\". The box lists your recent calls with this lead; the newest connected call is picked and its outcome, note and next date are used. No call? Under \"or log it without a call\" pick how it went, like Wrap Up. Check \"Next follow-up\" and tap \"Save & mark done\". Tapped it by mistake? Tap \"Undo\" within 5 seconds.",
      "Home also shows \"TODAY'S FOLLOW-UPS\". Tap \"View all\" to open the list."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M06-L09",
    "moduleId": "M06",
    "number": 9,
    "title": "Search, sort and filter follow-ups",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Follow-ups type a name, phone or place in \"Search name, phone, location\".",
      "Found the one you have finished? Tap \"Done\" on its row, pick the call (or how it went) and tap \"Save & mark done\". \"Undo\" brings it back within 5 seconds.",
      "Tap the sort chip and pick, for example, \"Tier (HOT first)\".",
      "Tap \"Filter\". Pick TIER, STAGE or SCHEDULE, for example \"Scheduled\". Tap \"Done\". The chip reads \"Filter · 1\".",
      "Open \"Filter\" and tap \"Clear all\" to remove the filters."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M06-L10",
    "moduleId": "M06",
    "number": 10,
    "title": "Schedule a follow-up without calling",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Follow-ups tap \"+\". Pick the lead.",
      "Tap \"Pick date & time\". Pick the day, tap \"OK\", pick the time, tap \"OK\". Add a note. Tap \"Schedule\".",
      "Or on the lead page tap the calendar icon \"Schedule follow-up\" and pick day and time.",
      "Or open \"Recent calls\" and tap \"Follow-up\" on a call.",
      "Follow-ups with no date are counted as \"need a date\". In \"Filter\", \"Needs scheduling\" shows them. Tap \"No date — tap to schedule\" to set a date.",
      "You cannot set a follow-up on a Won or Lost lead."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Schedule\""
    }
  },
  {
    "id": "M06-L11",
    "moduleId": "M06",
    "number": 11,
    "title": "Log a call result on the web Board",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads click \"Board\".",
      "Click a card. \"Log Call Outcome\" opens.",
      "Pick the result, for example \"Connected — qualifying\" or \"No Answer\".",
      "\"Going with a competitor\" asks for the name.",
      "Cards cannot be dragged. The stage moves by the result you log.",
      "Click ⓘ on a card to open the full lead."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "picking a result"
    }
  },
  {
    "id": "M06-L12",
    "moduleId": "M06",
    "number": 12,
    "title": "See your follow-ups on the web",
    "platform": "Web",
    "who": "P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Follow-ups\".",
      "Read \"X scheduled · Y overdue · Z need a date\". The Dashboard card \"Follow-ups due\" counts the same list.",
      "Each row shows the lead's name and when it is due. The oldest come first; a red time is overdue. A won lead shows a green \"WON\" tag.",
      "Click \"✓ Mark done\" when the follow-up is finished. Pick the call it was under \"Recent calls\", or pick how it went under \"or log it without a call\". Check \"Next follow-up\" and click \"Save & mark done\". \"Undo\" puts it back with its date.",
      "Click \"Open my leads\" to work on the lead. Click \"Refresh\" for the latest list."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M07-L01",
    "moduleId": "M07",
    "number": 1,
    "title": "Rules: how stages work",
    "platform": "Both",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Seven stages: New → Follow-up → Quoted → Negotiation → Prospect → Won, plus Lost.",
      "The app moves the lead from what you do. A connected call or a follow-up → Follow-up. A sent proposal → Quoted. \"Mark accepted\" or a booked order → Prospect.",
      "Won comes only when Accounts confirm the payment.",
      "A stage never drops by itself, except a Prospect with no payment request for 14 days.",
      "Stage is not temperature. HOT / WARM / COLD says how soon they will buy.",
      "Names differ by screen. The app kanban says \"Closing\" for Prospect. The web says \"Cold\" for New and \"Quote Shared\" for Quoted.",
      "On the web nobody can change the stage by hand."
    ],
    "minutes": {
      "android": 3,
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M07-L02",
    "moduleId": "M07",
    "number": 2,
    "title": "Mark a lead lost",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Mark lead lost\".",
      "In \"Why was this lead lost?\" pick the reason.",
      "\"Lost to competitor\" needs \"Pick a competitor\". \"Other\" needs \"Reason (required)\".",
      "Add \"Note (why) · optional\".",
      "Tap \"Mark as Lost\".",
      "A Won lead cannot be marked Lost."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Mark as Lost\""
    }
  },
  {
    "id": "M07-L03",
    "moduleId": "M07",
    "number": 3,
    "title": "Move a lead back one stage",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Move back\".",
      "Read \"This moves the lead back from X to Y.\" Add a reason. Tap \"Move to stage\".",
      "It moves exactly one stage. It is not offered on New, Won or Lost.",
      "On a Prospect lead tap \"No longer prospect\" → \"Revoke closing\".",
      "Only the person who declared Prospect, or a manager, may revoke it."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Move to stage\""
    }
  },
  {
    "id": "M07-L04",
    "moduleId": "M07",
    "number": 4,
    "title": "Move back a lost lead (reopen)",
    "platform": "Both",
    "who": "All sales (coordinator acts for her manager)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "App: open the Lost lead. Tap ⋮ → \"Reopen lead\". You see \"Lead reopened.\"",
      "Web: open the lead panel → Actions → \"Reopen lead\".",
      "The lead goes back to the stage it had before.",
      "The server decides who may: the owner, the owner's manager, a coordinator for that manager, an admin.",
      "If refused you see \"You cannot reopen this lead.\""
    ],
    "minutes": {
      "android": 1,
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "one tap reopens"
    }
  },
  {
    "id": "M07-L05",
    "moduleId": "M07",
    "number": 5,
    "title": "Close a lead on the web: Mark Lost or Mark Dead",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the lead panel → Actions.",
      "\"Mark Lost\" = not interested. Confirm.",
      "\"Mark Dead\" = cannot reach after many tries. Confirm.",
      "Do not mark a lead Won here. Won needs a payment confirmed by Accounts.",
      "After Lost or Dead the \"Mark …\" buttons go away."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M08-L01",
    "moduleId": "M08",
    "number": 1,
    "title": "Quick proposal: make a Quick Quote from a mobile number",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Quote\" in the bottom bar. The screen \"Quick Quote\" opens.",
      "Type the \"Customer number\". The app checks it on the 10th digit.",
      "New number: fill \"Name\" and \"Pincode\".",
      "Or tap a row under \"Recent leads\".",
      "Tap \"Build quote\". The proposal editor opens with the customer filled.",
      "\"Open calculators\" sizes the product first."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Build quote\""
    }
  },
  {
    "id": "M08-L02",
    "moduleId": "M08",
    "number": 2,
    "title": "Normal proposal: start from a lead and pick a calculator",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Proposal\".",
      "Pick \"Use a calculator first\" or \"Create proposal manually\".",
      "On \"Pick a Calculator\" tap a card: \"SS Water Tank\", \"Domestic Heat Pump\", \"Commercial Heat Pump\", \"Pool Heat Pump\".",
      "The lead's name and phone go with you.",
      "In the calculator tap \"Move to next step\". The proposal opens with the line filled."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L03",
    "moduleId": "M08",
    "number": 3,
    "title": "Calculator: SS Water Tank",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Pick \"Application type\" and \"Number of users / units\". Or tick \"I already know the tank capacity I need\".",
      "Pick \"Water quality / source (by TDS range)\".",
      "Pick \"Installation environment\" and \"Application\".",
      "Tap \"Calculate & recommend\".",
      "Tap the card you want on the quote: \"Recommended\" or \"Premium upsell\". Above 5000 L pick \"Option A\" or \"Option B\".",
      "Tap \"Move to next step\"."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Move to next step\""
    }
  },
  {
    "id": "M08-L04",
    "moduleId": "M08",
    "number": 4,
    "title": "Calculator: Domestic Heat Pump",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Answer all ten questions: \"Property type\", \"Covered area\", washrooms, family members, staff.",
      "Then reverse line, \"Area / climate zone\", usage per person, bath tubs, kitchen.",
      "Tap \"Calculate requirement & get model\".",
      "Read \"Capacity summary\".",
      "Tap the model card you want to quote.",
      "Tap \"Move to next step\"."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Move to next step\""
    }
  },
  {
    "id": "M08-L05",
    "moduleId": "M08",
    "number": 5,
    "title": "Calculator: Commercial Heat Pump — enter the property",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Pick \"Location / Climate Zone *\" and \"Property type *\".",
      "Pick \"Construction type *\". For many blocks enter the number.",
      "Enter rooms, beds or persons, kitchen and tubs.",
      "For many blocks use \"DISTRIBUTE QUICK-FILL\" → \"Distribute →\", then edit each block.",
      "Pick \"Usage intensity *\" and \"Reverse line *\".",
      "Tap \"Calculate & get recommendation\"."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L06",
    "moduleId": "M08",
    "number": 6,
    "title": "Calculator: Commercial Heat Pump — choose the option and quote",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Read \"Whole-property load\".",
      "Tap \"Option 1 · Budget\" or \"Option 2 · Premium\". Budget is selected first.",
      "Tap \"Show ROI\" to compare with electric, diesel and gas.",
      "Read \"Engineering notes\".",
      "Tap \"Move to next step\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Move to next step\""
    }
  },
  {
    "id": "M08-L07",
    "moduleId": "M08",
    "number": 7,
    "title": "Calculator: Pool Heat Pump — enter the pool",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Stay on the tab \"Calculate & Recommend\".",
      "Pick \"Climate zone *\".",
      "Choose \"Enter by dimensions\" or \"Enter by volume\" and fill it.",
      "Pick \"Placement *\", \"Application *\", \"Winter ops\".",
      "Pick \"Heat-up target\" and \"Target temp\".",
      "Tap \"Calculate & Generate ROI\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L08",
    "moduleId": "M08",
    "number": 8,
    "title": "Calculator: Pool Heat Pump — choose the option and quote",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"Page 1 · Recommendation\" read \"Volume\" and \"Heat load\".",
      "Tap \"Option 1 · Standard\" or \"Option 2 · Variable Load\". Option 2 is selected first.",
      "Read \"Why pick Option 2?\".",
      "Open \"Page 2 · ROI Analysis\" and show the savings and payback.",
      "Tap \"Move to next step\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Move to next step\""
    }
  },
  {
    "id": "M08-L09",
    "moduleId": "M08",
    "number": 9,
    "title": "Pool Heat Pump: check what one model can do",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the tab \"Select Model Directly\".",
      "Pick \"Pool heat pump model *\", \"Qty\", \"Climate zone *\", \"Placement *\".",
      "Optional: fill \"OPTIONAL · FIT CHECK\".",
      "Tap \"Show capability envelope\".",
      "This tab is information only. It makes no ROI and no proposal."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L10",
    "moduleId": "M08",
    "number": 10,
    "title": "Build a proposal by hand: customer and products",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "The editor \"NEW PROPOSAL\" opens. Check \"CUSTOMER NAME *\".",
      "Under \"LINE ITEMS\" tap \"Pick product\", or type in \"Search an item\" and tap a result.",
      "Set \"QTY\". Pick the \"GST\" chip.",
      "\"RATE (₹)\" cannot be typed. It comes from the catalogue or the calculator.",
      "Tap \"Add line item\" for more. ✕ removes a line.",
      "A line must be a real catalogue product."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L11",
    "moduleId": "M08",
    "number": 11,
    "title": "Finish the proposal: charges, totals, PDF prices, save",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Under \"CHARGES\" set Lifting, Transportation, Installation: \"Inclusive\", \"Client's scope\" or \"Add amount\".",
      "Check \"Subtotal\", \"GST\", \"Grand Total\".",
      "Add \"NOTES (OPTIONAL)\" and \"TERMS & CONDITIONS (OPTIONAL)\".",
      "Under \"PRICES ON THE CUSTOMER'S PDF\" pick \"Show discount\" or \"Net rate only\".",
      "Tap \"Save draft proposal\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save draft proposal\""
    }
  },
  {
    "id": "M08-L12",
    "moduleId": "M08",
    "number": 12,
    "title": "Send the proposal to the customer",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After saving you see \"Proposal created · draft\".",
      "Tap \"Download PDF\" to check it.",
      "Tap \"Share on WhatsApp\". It marks the proposal sent and opens the customer's chat.",
      "Or tap \"Mark as sent\".",
      "When the customer says yes tap \"Mark accepted\". The lead moves to Closing, not Won.",
      "Tap \"Done\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Share on WhatsApp\""
    }
  },
  {
    "id": "M08-L13",
    "moduleId": "M08",
    "number": 13,
    "title": "Work with a proposal from the lead page",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead open \"Files & quotes\".",
      "Read the status pill: \"Draft\", \"Sent\", \"Accepted\", \"Rejected\", \"Expired\".",
      "Tap the card. Pick \"View PDF\", \"Share PDF\" or \"Share on WhatsApp\".",
      "A draft also has \"Edit proposal\", \"Mark as Sent\", \"Delete draft\".",
      "A sent proposal cannot be edited. Its PDF format shows a 🔒 chip."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L14",
    "moduleId": "M08",
    "number": 14,
    "title": "Find your sent proposals",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Sales & Orders\".",
      "Stay on the tab \"Sent Proposals\".",
      "Type in \"Search by lead / customer name\".",
      "Read the card: number, status chip, total, \"Valid until\".",
      "Pull down to refresh."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L15",
    "moduleId": "M08",
    "number": 15,
    "title": "Start or revise a quote from the call wrap-up",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Wrap Up (Connected) tap \"Create Quote\".",
      "Pick \"Use a calculator\" or \"Enter manually\".",
      "On a Quoted or Negotiation lead the tile reads \"Revise Proposal\".",
      "This is not an outcome. Come back, pick an outcome and tap \"Save & Next\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a real call"
    }
  },
  {
    "id": "M08-L16",
    "moduleId": "M08",
    "number": 16,
    "title": "Quote at the customer's place with Meeting Mode",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Meetings\" → banner \"Initiate Meeting Mode\".",
      "Type in \"Search leads…\" and tap the lead.",
      "Location must be on. If not, tap \"Open settings\".",
      "The calculators open for that lead.",
      "\"Open calculators\" works without a lead. \"New proposal\" opens the editor.",
      "\"Active session found\" → \"Resume\" or \"Start new\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "stamps GPS on the lead"
    }
  },
  {
    "id": "M08-L17",
    "moduleId": "M08",
    "number": 17,
    "title": "Quick Quote on the web: start and choose the customer",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click \"Quick Quote\" in the sidebar. The page \"Create Proposal\" opens.",
      "Fill \"Title *\". Pick \"Contact\" and \"Account\". ➕ creates a new account.",
      "Pick \"Buyer State (Place of Supply)\" and \"Customer Type\".",
      "Fix the contact under \"Update Contact Details\" if needed.",
      "Check \"Client Details\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L18",
    "moduleId": "M08",
    "number": 18,
    "title": "Quick Quote on the web: add products",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Pick the \"Document GST Mode:\".",
      "Under \"Line Items\" click \"Browse Products\" or \"Add Item\".",
      "Fill Qty and GST %. \"Rate (INR)\" is read-only.",
      "Lines set by a calculator are locked.",
      "The trash icon removes a line."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L19",
    "moduleId": "M08",
    "number": 19,
    "title": "Quick Quote on the web: charges, content, terms and totals",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Under \"CHARGES\" set Lifting, Transportation, Installation.",
      "Under \"Proposal Content\" switch sections on or off.",
      "Pick the \"T&C Template\".",
      "Add \"Notes\".",
      "Check \"Summary\" down to \"Grand Total\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L20",
    "moduleId": "M08",
    "number": 20,
    "title": "Quick Quote on the web: save, PDF and send",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click \"Save as Draft\".",
      "Under \"Pricing\" pick \"Show discount\" or \"Net rate only\". It locks once sent.",
      "Click \"Download PDF\".",
      "Click \"Send Proposal\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send Proposal\""
    }
  },
  {
    "id": "M08-L21",
    "moduleId": "M08",
    "number": 21,
    "title": "Find and manage your proposals on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Proposals\".",
      "Search, or filter by status.",
      "Click a row to edit it.",
      "Change the status in the row dropdown.",
      "A clock badge means it waits for discount approval.",
      "Use the row actions to download the PDF or delete."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L01",
    "moduleId": "M09",
    "number": 1,
    "title": "Quick sale: say who is buying",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap \"Quick Sale\".",
      "Under \"Who is buying?\" keep \"Customer\".",
      "Type the \"Customer mobile\". It is checked on the 10th digit.",
      "New number: fill \"Name\" and \"Pincode\".",
      "A past customer shows \"Won customer — repeat order\".",
      "Tap \"Take order\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Take order\""
    }
  },
  {
    "id": "M09-L02",
    "moduleId": "M09",
    "number": 2,
    "title": "Quick sale: add the products",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Choose product\" and pick from the catalogue.",
      "Read the line: SKU, name, HSN, GST, list rate.",
      "Change quantity with − / +.",
      "✕ removes a line.",
      "Tap \"Continue\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L03",
    "moduleId": "M09",
    "number": 3,
    "title": "Quick sale: answer the terms, review and confirm",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"What's included\" answer \"Transportation\", \"Lifting\", \"Installation\".",
      "Pick \"Inclusive\", \"Client's scope\" or \"Add amount\". Nothing is pre-selected.",
      "For \"Add amount\" type \"Amount ₹\" and pick the GST.",
      "Check the Review step. Totals are indicative.",
      "Tap \"Confirm order\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm order\""
    }
  },
  {
    "id": "M09-L04",
    "moduleId": "M09",
    "number": 4,
    "title": "After the quick sale: the \"Order booked\" screen",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Read the order number and \"Order received\".",
      "It is NOT Won yet: \"this counts as Won once Accounts confirms.\"",
      "Tap \"Add shipping details\", or \"Skip for now\" and add them later.",
      "Tap \"Record payment\" to go and record the money.",
      "Or tap \"Done\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a booked order"
    }
  },
  {
    "id": "M09-L05",
    "moduleId": "M09",
    "number": 5,
    "title": "Add or change the delivery address of an order",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"Order booked\" tap \"Add shipping details\". Or on the order tap \"Add delivery address →\".",
      "Fill \"Receiver name\", \"Phone\", \"Address line\", \"Pincode\". City and state fill in.",
      "Tap \"Save delivery details\".",
      "Later tap \"Edit\" beside Ship to.",
      "After dispatch the address is locked. Contact ops."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save delivery details\""
    }
  },
  {
    "id": "M09-L06",
    "moduleId": "M09",
    "number": 6,
    "title": "Convert a proposal into a sales order",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap the proposal → \"Convert to Sales Order\". Or in \"Sent Proposals\" tap \"Convert to SO\".",
      "Tap \"Upload payment proof\" and pick the screenshot.",
      "Check \"Amount received (₹)\". Add the UTR if you have it.",
      "Under \"ORDER TERMS\" answer all three with \"Yes\" or \"No\".",
      "Tap \"Submit for payment review\".",
      "Accounts confirm. Then the deal is Won."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit for payment review\""
    }
  },
  {
    "id": "M09-L07",
    "moduleId": "M09",
    "number": 7,
    "title": "Bill or ship an order to a different address",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the convert sheet tick \"Different billing details & address\".",
      "Pick a saved address or \"Add new\". Fill \"Billed-to name *\" and the address.",
      "Read the tax line: \"Same state → CGST + SGST\" or \"Inter-state → IGST\".",
      "Tap \"Use these billing details\".",
      "For goods, tick \"Different shipping details & address\".",
      "\"Save to customer\" keeps the address for next time."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L08",
    "moduleId": "M09",
    "number": 8,
    "title": "Find and read a sales order",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Sales & Orders\" → tab \"Sales Orders\".",
      "Read the status chip. \"Pending PC\" means the payment waits with Accounts.",
      "Tap the card. The screen \"Sales Order\" opens.",
      "Read \"Parties\", \"Order lines & amounts\", \"Payment\", \"Terms\".",
      "A lead also lists its orders under \"Sales orders\".",
      "Home shows your last wins under \"RECENT WINS\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L09",
    "moduleId": "M09",
    "number": 9,
    "title": "Record a customer payment",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the order. In the \"Payment\" card tap \"Record payment\".",
      "Tap \"Upload payment proof\". A screenshot is required on your own order.",
      "Check the amount. Add the UTR if you have it.",
      "Tap \"Send to Accounts\".",
      "The deal is Won only when Accounts confirm."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send to Accounts\""
    }
  },
  {
    "id": "M09-L10",
    "moduleId": "M09",
    "number": 10,
    "title": "Change the terms of an order",
    "platform": "Android",
    "who": "The person who raised the order",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the order. In \"Terms\" tap \"Edit\".",
      "Change the three Yes / No answers. Tap \"Save terms\".",
      "You can do this only before the payment is confirmed.",
      "If a banner says your answer differs from the proposal, tap \"Keep X\" or \"Use Y (proposal)\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save terms\""
    }
  },
  {
    "id": "M09-L11",
    "moduleId": "M09",
    "number": 11,
    "title": "Edit or delete a draft order",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the tab \"Sales Orders\" find a draft. The hint reads \"Draft — no approval\".",
      "Tap \"✎ Edit\" to change it.",
      "Tap \"🗑 Delete\" → \"Delete\". It is deleted at once.",
      "A draft held for discount approval reads \"Waiting on discount approval\". It can be edited but not deleted."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Delete\""
    }
  },
  {
    "id": "M09-L12",
    "moduleId": "M09",
    "number": 12,
    "title": "Ask to edit a confirmed order",
    "platform": "Android",
    "who": "All sales (when the server allows)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a confirmed order tap \"✎ Edit\". The hint reads \"Needs approval\".",
      "Change quantity, discount or services. Add or remove a line.",
      "Tap \"Next: add reason\".",
      "Pick a reason chip and write at least 10 characters.",
      "Tap \"Send for approval\". Admin / Accounts decide.",
      "The card shows \"EDIT WAITING\". \"Withdraw request\" takes it back."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send for approval\""
    }
  },
  {
    "id": "M09-L13",
    "moduleId": "M09",
    "number": 13,
    "title": "Ask to delete a confirmed order",
    "platform": "Android",
    "who": "All sales (when the server allows)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a confirmed order tap \"🗑 Delete\".",
      "Pick a reason: \"Duplicate order\", \"Customer cancelled\", \"Made by mistake\", \"Other\". Write at least 10 characters.",
      "Read the banner: after approval the lead goes from Won back to Hot.",
      "Tap \"Send delete for approval\".",
      "Some orders cannot be deleted. The sheet tells you why."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send delete for approval\""
    }
  },
  {
    "id": "M09-L14",
    "moduleId": "M09",
    "number": 14,
    "title": "Find and read an order on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Orders\" (or \"My Orders\").",
      "Search, or filter by status.",
      "Click a row.",
      "Read \"Customer\", \"Order Total\", \"Progress\", the addresses and the line items.",
      "On a dealer order read the block \"Through dealer\".",
      "Term chips with a tooltip show a mismatch with the proposal."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L15",
    "moduleId": "M09",
    "number": 15,
    "title": "Create a sales order on the web: customer and addresses",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Orders click \"Create Sales Order\".",
      "Fill \"Customer Details\".",
      "Fill \"Billing Address\". Click \"Copy from Billing\" for shipping.",
      "Use \"Bill To / Ship To Override\" for a different party.",
      "Set \"GST & Export\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L16",
    "moduleId": "M09",
    "number": 16,
    "title": "Create a sales order on the web: products and save",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Under \"Line Items\" click \"Product Grid\" or \"Add Row\".",
      "Set Qty, Disc %, GST % and \"Source\".",
      "Set \"Order Discount\" if any.",
      "Add \"Customer Notes\".",
      "Click \"Save as Draft\" or \"Save & Confirm\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M09-L17",
    "moduleId": "M09",
    "number": 17,
    "title": "Edit, confirm or cancel an order on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Only a draft order shows \"Edit\" and Delete.",
      "Open the draft and click \"Confirm Order\".",
      "The Cancel button cancels an order that is not delivered.",
      "A confirmed order cannot be edited on the web."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M09-L18",
    "moduleId": "M09",
    "number": 18,
    "title": "Convert a proposal into a sales order on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In \"Proposals\" use the row action \"Convert to Sales Order\". Or open the proposal and click \"Convert to Sales Order\".",
      "Confirm. The line items lock.",
      "A banner \"Order created. This dealer owes …\" is a warning only. The order is made.",
      "Click \"Open the sales order\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M09-L19",
    "moduleId": "M09",
    "number": 19,
    "title": "Mark a service line done and split a discount with a service partner",
    "platform": "Web",
    "who": "P01, P02 (when the card is shown)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the order. Under \"Service Fulfillment\" click \"Mark Complete\".",
      "In the card \"Additional discount\" fill \"Discount %\", \"Service partner\", \"Service scope (required)\".",
      "Click \"Preview\", then save.",
      "Only \"Amount A\" goes to the invoice."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M09-L20",
    "moduleId": "M09",
    "number": 20,
    "title": "See money still unpaid on your orders (My Outstanding)",
    "platform": "Web",
    "who": "P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"My Outstanding\".",
      "Read \"Total outstanding\".",
      "Read each order: \"Order amount\", \"Paid\", \"Remaining balance\".",
      "Click the order number to go to Orders."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L01",
    "moduleId": "M10",
    "number": 1,
    "title": "Rules: discounts and approvals",
    "platform": "Both",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Every line has three bands. Up to your own limit: you just give it.",
      "Above your limit, up to the product maximum: the quote or order is held and goes for approval by itself.",
      "Above the product maximum: refused. No approver can clear it.",
      "The whole-order discount has no approval band. Its ceiling is the strictest product, never more than 7.5%.",
      "Charges are never discounted.",
      "A held proposal: no PDF, no WhatsApp, no \"Mark as sent\". A held Quick Sale books nothing.",
      "Coordinators and reps never approve. A manager approves only inside his own slab."
    ],
    "minutes": {
      "android": 3,
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M10-L02",
    "moduleId": "M10",
    "number": 2,
    "title": "Give a discount on a proposal",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a line type \"DISC %\". The hint shows \"self-serve ≤ X%\".",
      "The chip \"needs approval\" means it will be held.",
      "Red \"Max X% for this product\" means it is refused. Lower it.",
      "For the whole order use \"DISCOUNT\" with \"%\" or \"₹\".",
      "Above the ceiling Save is disabled."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L03",
    "moduleId": "M10",
    "number": 3,
    "title": "Give a discount in a Quick Sale",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a line type \"Discount %\". Read the hint under it.",
      "On the step \"Order discount\" pick \"%\" or \"₹\" and type the value.",
      "Read \"Self-serve up to X% on this order\".",
      "The Review banner says if the order goes to your manager.",
      "If refused, read the red panel, lower the number and confirm again."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L04",
    "moduleId": "M10",
    "number": 4,
    "title": "When a quote or order is held: track, remind, withdraw",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "A held proposal shows \"AWAITING APPROVAL\". Tap \"Refresh status\".",
      "A held Quick Sale shows \"Sent for approval\". Tap \"Track this request\".",
      "On the lead the banner shows the pending request. Tap \"View status\" or \"Nudge manager\".",
      "Under \"Sales orders\" tap \"Nudge\" or \"Withdraw\". After a refusal tap \"Start again, lower\".",
      "Profile → \"My discount requests\" lists all your requests.",
      "The lead's \"Approvals\" section shows each decision."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L05",
    "moduleId": "M10",
    "number": 5,
    "title": "Give a discount on the web and raise a request",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a line type Disc %. The tooltip shows \"Max allowed: N%\".",
      "Under \"Proposal Discount\" pick \"₹ Amount\" or \"% Percentage\".",
      "Read \"Allowance limit for this order: N%\".",
      "If a line is over your limit click \"Raise Discount Request (N items)\".",
      "The banner \"Awaiting approval to generate proposal\" means no PDF and no send yet."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "raising the request"
    }
  },
  {
    "id": "M10-L06",
    "moduleId": "M10",
    "number": 6,
    "title": "Track your discount requests on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Discount Requests\" (managers: \"Discount Approvals\").",
      "Filter \"pending\", \"approved\", \"rejected\".",
      "Read the card and the chip \"With manager\" or \"With MD\".",
      "On a dealer order read the block \"Through dealer\".",
      "Write to the approver in \"Add a message...\".",
      "Click \"View Proposal\" to open the document."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L01",
    "moduleId": "M11",
    "number": 1,
    "title": "Rules: what to do for a dealer",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "\"Quote for a dealer\" / \"Through a dealer\": the customer buys, the dealer is billed. Two prices. The margin is calculated.",
      "\"Quote to dealer\": the dealer is the buyer of the quote.",
      "Dealer stock sale: the dealer buys stock for himself. No customer, no lead.",
      "A dealer belongs to one manager. For someone else's dealer use \"Request access\".",
      "To quote through a dealer the dealer needs bank, phone and pincode.",
      "A call to an active dealer needs no wrap-up. A call to a prospect needs one outcome.",
      "Sending a lead to a dealer does not change the owner."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M11-L02",
    "moduleId": "M11",
    "number": 2,
    "title": "Quote for a customer who buys through a dealer",
    "platform": "Android",
    "who": "Reps and managers; coordinator for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Quick Quote tap the chip \"Quote for a dealer\".",
      "In \"Quote on behalf of a dealer\" read each chip: \"Ready\" or what is missing.",
      "Tap the dealer. The chip shows \"Quoting via dealer\".",
      "For an incomplete dealer fill the sheet \"Complete dealer\": bank, phone, pincode. Tap \"Save & use this dealer\".",
      "✕ on the chip removes the dealer."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L03",
    "moduleId": "M11",
    "number": 3,
    "title": "Quote to a dealer (the dealer is the buyer)",
    "platform": "Android",
    "who": "Reps and managers; coordinator for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Quick Quote tap \"Quote to dealer\".",
      "Pick the dealer in \"Quote to a dealer\".",
      "The editor opens as \"QUOTE TO DEALER\".",
      "Price each line with \"DISC %\". There is no whole-order discount.",
      "Save and send as usual."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L04",
    "moduleId": "M11",
    "number": 4,
    "title": "Quick sale to a customer through a dealer",
    "platform": "Android",
    "who": "Reps and managers; coordinator with \"Book for\" on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Quick Sale keep \"Customer\" and turn on \"Through a dealer\".",
      "Tap \"Choose dealer\". Search under \"On file\".",
      "Under \"Who is invoiced?\" pick \"Dealer\" or \"Customer\".",
      "On each line type \"Dealer rate % (off list)\". Read the verdict under it.",
      "On Review read \"Customer pays\", \"Dealer billed\", \"Dealer margin\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L05",
    "moduleId": "M11",
    "number": 5,
    "title": "Sell stock to a dealer (dealer stock sale)",
    "platform": "Android",
    "who": "Reps and managers; coordinator with \"Book for\" on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Quick Sale under \"Who is buying?\" tap \"Dealer\".",
      "Tap \"Choose dealer\". No customer and no lead is created.",
      "On each line type the dealer's price off list in \"Discount %\".",
      "\"Order discount\" works as on any order: leave it empty or stay within \"Self-serve up to …\".",
      "Review shows the list price struck through, the % off and \"Dealer subtotal (indicative)\".",
      "The booked screen shows \"Dealer billed ₹…\", the effective dealer rate and the order total + GST."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L06",
    "moduleId": "M11",
    "number": 6,
    "title": "Manage dealers: open your dealer list",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Active Dealers\".",
      "Read \"Your dealers only\" or \"Working for manager\".",
      "Type in \"Search your dealers\".",
      "Pick the period. Tap the chip \"Address missing · N\".",
      "Read a card: \"Assigned\", \"Converted\", \"Dealer billed\".",
      "Tap the phone icon to call. Tap the card to open the dealer."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L07",
    "moduleId": "M11",
    "number": 7,
    "title": "Add a dealer",
    "platform": "Android",
    "who": "All who reach the sheet",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"+ Add dealer\" (or \"＋ New dealer\" in Quick Sale, \"Add a dealer\" in Quick Quote).",
      "Fill \"Dealer name\" and \"Mobile (10 digits)\".",
      "Pick the product categories.",
      "Type the \"GSTIN (optional)\" and tap \"Verify\". Tap \"Use\" on a GST suggestion.",
      "Fill the \"Billing address\" with the pincode. Add bank details if you have them.",
      "Tap \"Add dealer\".",
      "If it already exists and is yours, tap \"Use dealer name\"."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add dealer\""
    }
  },
  {
    "id": "M11-L08",
    "moduleId": "M11",
    "number": 8,
    "title": "Ask for access to another manager's dealer",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "When the dealer exists under someone else tap \"Request access\".",
      "Pick the product categories you want to quote.",
      "Add a \"Note for the admin (optional)\".",
      "Tap \"Send request\".",
      "Menu → \"Access Requests\" → \"Dealer access requests\" shows it.",
      "Only an admin approves dealer access."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send request\""
    }
  },
  {
    "id": "M11-L09",
    "moduleId": "M11",
    "number": 9,
    "title": "Open a dealer and read its numbers",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Active Dealers tap a dealer.",
      "Read \"Leads & sales\".",
      "Read \"Proposals & orders\". A dash means \"could not ask\", not zero.",
      "Tap \"View all ›\".",
      "Read \"Delivery & bank\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L10",
    "moduleId": "M11",
    "number": 10,
    "title": "Fill in a dealer's details: phone, GST, categories",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the dealer tap \"Edit\" in the \"Overview\" card.",
      "Fill a blank \"Name\", \"Phone\" or \"Pincode\". A filled one shows \"locked\".",
      "Type the \"GSTIN\" and tap \"Verify\".",
      "Fix \"Email\" and \"Website\".",
      "In \"Product categories\" tap \"Add\", pick, tap \"Add categories\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M11-L11",
    "moduleId": "M11",
    "number": 11,
    "title": "Fill in a dealer's address and bank, then save",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In edit mode fill \"Billing address\" with the pincode.",
      "Tick \"Different shipping address\" if goods go elsewhere.",
      "In \"Bank account\" fill holder name, account number, \"IFSC\" and \"Bank name\".",
      "Tap \"Save\".",
      "If the bank part fails, the earlier parts stay saved. Try again."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M11-L12",
    "moduleId": "M11",
    "number": 12,
    "title": "Work a dealer's proposals and orders",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the dealer tap \"View all ›\". Tabs: \"Proposals\" and \"Sales Orders\".",
      "Read the status chip and the discount chip.",
      "Tap \"Download\", \"Mark sent\" or \"Edit\".",
      "A line under the buttons says why a button is disabled.",
      "Open the tab \"Sales Orders\" and tap a row."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L13",
    "moduleId": "M11",
    "number": 13,
    "title": "Mark a dealer proposal won",
    "platform": "Android",
    "who": "Managers and coordinators (dealer access)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the proposal tap \"Mark won\". The sheet \"Billing & shipping\" opens.",
      "Check \"Bill to\". If there is no full GSTIN pick \"Billed in\".",
      "Under \"Ship to\" pick where the goods go.",
      "Add \"Amount received\" and \"Payment screenshot\" if money came.",
      "Tap \"Create sales order\".",
      "With no screenshot the order is won on credit."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create sales order\""
    }
  },
  {
    "id": "M11-L14",
    "moduleId": "M11",
    "number": 14,
    "title": "Find your prospect dealers",
    "platform": "Android",
    "who": "Managers and coordinators; reps only if switched on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Prospect Dealers\".",
      "Tabs: \"Prospects (N)\" and \"Active dealers (N)\".",
      "Search with at least 2 characters.",
      "Filter by stage chip and by follow-up: \"Overdue\", \"Today\", \"This week\".",
      "Tap the sort icon.",
      "Tap a row to open the prospect."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L15",
    "moduleId": "M11",
    "number": 15,
    "title": "Call a prospect dealer and save the wrap-up",
    "platform": "Android",
    "who": "Managers and coordinators; reps only if switched on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the prospect tap \"Call\".",
      "After the call tap one \"Outcome\" chip.",
      "Optional: set \"Fit (override)\" and \"Next follow-up\".",
      "Read the card \"After saving\".",
      "Tap \"Save wrap-up\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save wrap-up\""
    }
  },
  {
    "id": "M11-L16",
    "moduleId": "M11",
    "number": 16,
    "title": "Make a proposal for a prospect dealer",
    "platform": "Android",
    "who": "Managers and coordinators; reps only if switched on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the prospect tap \"Make proposal\".",
      "Fill \"Dealer name\", \"Mobile (10 digits)\", \"Pincode (6 digits)\" and the categories.",
      "Tap \"Make proposal\".",
      "It stays a prospect until it is appointed.",
      "If a category is held by someone else tap \"Request access\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Make proposal\""
    }
  },
  {
    "id": "M11-L17",
    "moduleId": "M11",
    "number": 17,
    "title": "Appoint a prospect as a dealer",
    "platform": "Android",
    "who": "Managers; coordinator for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the prospect tap \"Appoint as dealer\". Or in the Quick Sale dealer picker open \"Prospects\" and tap the firm.",
      "Check name, mobile, GSTIN, pincode and categories.",
      "Read the warning: it closes the prospect as Appointed and leaves your lead list.",
      "Tap \"Appoint & use\".",
      "This cannot be undone by you."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Appoint & use\""
    }
  },
  {
    "id": "M11-L18",
    "moduleId": "M11",
    "number": 18,
    "title": "Move a lead to prospect dealers, or back",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Wrap Up (Connected) tap \"Prospect dealer\" → \"Mark as prospect\".",
      "The lead leaves your sales pipeline and goes to Dealers → Prospects.",
      "To undo from the lead: ⋮ → \"Remove from prospect dealers\".",
      "To undo from the prospect screen: \"Not a dealer\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Mark as prospect\""
    }
  },
  {
    "id": "M11-L19",
    "moduleId": "M11",
    "number": 19,
    "title": "Call an active dealer and keep its contacts",
    "platform": "Android",
    "who": "Managers and coordinators; reps only if switched on",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Prospect Dealers open the tab \"Active dealers\" and tap a dealer.",
      "Tap \"Call\". The call logs by itself.",
      "After a WhatsApp or a visit tap \"Log contact / last-contacted\".",
      "Under \"Contacts\" tap \"Add\". Fill \"Name\", \"Role\", \"Phone\". Tap \"Save contact\".",
      "Use the row menu for \"Make primary\" or \"Delete\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save contact\""
    }
  },
  {
    "id": "M11-L20",
    "moduleId": "M11",
    "number": 20,
    "title": "Send a lead to a dealer and know who owns it",
    "platform": "Android",
    "who": "Reps",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the sheet \"📲 Dispatch to Dealer\" from the lead.",
      "Pick a dealer. The list is filtered by product and pincode.",
      "Read the \"WhatsApp message preview\". Tap \"Send on WhatsApp\".",
      "You stay the owner. The manager is told.",
      "The lead shows \"Assigned to Dealer: name\". Lists show \"With Dealer · name\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send on WhatsApp\""
    }
  },
  {
    "id": "M11-L21",
    "moduleId": "M11",
    "number": 21,
    "title": "Open your dealers on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"My dealers\".",
      "Read the four totals.",
      "Type in \"Search dealer or city…\". Pick the period and the address filter.",
      "Click the dealer NAME to open its leads.",
      "Click \"Details\" for the drawer.",
      "\"Export\" downloads the list."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L22",
    "moduleId": "M11",
    "number": 22,
    "title": "Add a dealer on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"My dealers\" click \"Add dealer\".",
      "Fill \"Dealer name *\" and \"Pincode *\". Only these two are required.",
      "Add phone, GSTIN and the billing lines.",
      "Add \"Credit limit (₹)\" and \"Credit days\" if known. Blank means \"not recorded\".",
      "Click \"Add dealer\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add dealer\""
    }
  },
  {
    "id": "M11-L23",
    "moduleId": "M11",
    "number": 23,
    "title": "Read a dealer and ask for a product category on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the dealer drawer. Read \"Overview\".",
      "Read \"Ownership\" and \"Managers by product category\".",
      "Click \"Request a category\".",
      "Tick at least one category. Add the reason.",
      "Click \"Send request\".",
      "Read \"Address & bank\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send request\""
    }
  },
  {
    "id": "M11-L24",
    "moduleId": "M11",
    "number": 24,
    "title": "Edit a dealer on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the drawer click \"Edit dealer\".",
      "Fill an empty Name, Phone or Pincode. A filled one is \"locked\".",
      "Type the GSTIN and click \"Verify\".",
      "Fill \"Shipping address\" and \"Bank account\".",
      "Click \"Save\".",
      "A manager can reveal the saved account number. A coordinator cannot."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M11-L25",
    "moduleId": "M11",
    "number": 25,
    "title": "Check a dealer's credit and send the ledger on WhatsApp",
    "platform": "Web",
    "who": "P01; P02 for her manager (when the block is shown)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the drawer find \"Credit balance\".",
      "Read the chip, for example \"₹… over limit\".",
      "Under \"Ledger on WhatsApp\" tick the box.",
      "Click \"Send statement now\".",
      "Credit warns. It never blocks an order."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send statement now\""
    }
  },
  {
    "id": "M11-L26",
    "moduleId": "M11",
    "number": 26,
    "title": "Mark a dealer's lead won on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click the dealer name. The panel \"Dealer leads\" opens.",
      "Click \"Mark won\" on the lead.",
      "If \"Confirm the order\" opens, click \"Add product\". Fill Quantity, \"Customer discount %\", \"Dealer rate %\".",
      "Answer every row under \"Charges\". Pick \"Customer's state\".",
      "Click \"Confirm order and mark won\".",
      "An amber notice means it waits for discount approval. The lead is not won yet."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm order and mark won\""
    }
  },
  {
    "id": "M11-L27",
    "moduleId": "M11",
    "number": 27,
    "title": "Find your prospect dealers on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Prospect dealers\".",
      "Read the four tiles.",
      "Search. Filter by \"State\", \"Fit\" and \"Follow-up\".",
      "Click a stage pill.",
      "Pick the sort."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L28",
    "moduleId": "M11",
    "number": 28,
    "title": "Call a prospect dealer and save the wrap-up on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Click \"Call\" on the row.",
      "Click the row to open the drawer.",
      "Under \"Wrap-up\" pick the \"Outcome\".",
      "Set \"Fit\" and \"Next follow-up\". Add a note.",
      "Click \"Save wrap-up\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save wrap-up\""
    }
  },
  {
    "id": "M11-L29",
    "moduleId": "M11",
    "number": 29,
    "title": "Make a proposal for a prospect, appoint it, or remove it, on the web",
    "platform": "Web",
    "who": "P01; P02 for her manager",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the drawer click \"Make proposal\". Fill pincode and categories. Click \"Continue\", then \"Open the proposal\".",
      "Click \"Appoint as dealer\", check the form, click \"Appoint\".",
      "Click \"Not a dealer\" → \"Yes, not a dealer\" to remove a wrong shop."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each confirm"
    }
  },
  {
    "id": "M11-L30",
    "moduleId": "M11",
    "number": 30,
    "title": "Give a lead to a dealer on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the lead panel click \"Assign to dealer\".",
      "Search in \"Search by name, team or dealer…\".",
      "Pick under \"Dealers\". A dealer is in addition to the rep.",
      "If the lead has no owner, assign a sales member first.",
      "Click \"Confirm reassign\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm reassign\""
    }
  },
  {
    "id": "M12-L01",
    "moduleId": "M12",
    "number": 1,
    "title": "Field day: start and stop",
    "platform": "Android",
    "who": "All sales (card on Home for field agents)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Field Sessions\". Find the card \"Field day\".",
      "Tap \"Start field day\". The card reads \"On the ground\".",
      "When you finish tap \"Stop\".",
      "In \"Field day wrapped up\" check \"Distance travelled (km)\".",
      "Tap \"Keep measured\" or type the km and tap \"Save distance\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "starts a real field day"
    }
  },
  {
    "id": "M12-L02",
    "moduleId": "M12",
    "number": 2,
    "title": "Capture a field lead: where and who",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Home tap \"Add Lead\" → \"Field Lead\".",
      "Wait for \"GPS locked\". If \"Approximate location\" tap \"Retake\".",
      "Tap \"Scan visiting card\", or type \"CONTACT NAME\" and the rest by hand.",
      "Mobile is optional.",
      "Tap \"Continue → Step 2\".",
      "If the number exists you see \"Open it\" or \"Request access\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "uses GPS and camera"
    }
  },
  {
    "id": "M12-L03",
    "moduleId": "M12",
    "number": 3,
    "title": "Capture a field lead: photo, qualify and save",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"Step 2 of 3 · Photo\" tap \"TAKE PHOTO\". The storefront photo is required.",
      "Tap \"+ ADD PHOTO\" for more, up to 6.",
      "On \"Step 3 of 3 · Qualify\" pick \"PRODUCT INTEREST\".",
      "Pick \"WHOSE NUMBER IS THIS?\", \"BUDGET\", \"TIMELINE\".",
      "Add at least one row under \"REFERENCES\".",
      "Tap \"Save lead\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "uses the camera"
    }
  },
  {
    "id": "M12-L04",
    "moduleId": "M12",
    "number": 4,
    "title": "Field Activity board: go back to a site and get the owner's number",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "\"Add Lead\" → \"View Field Activity board\".",
      "Read the counts: \"Captured\", \"Site contact\", \"Referred on\", \"Contact Found\".",
      "Tap \"Revisit\" on a row.",
      "Type the mobile. Pick \"Decision-maker's number\", \"Someone else (guard / gatekeeper)\" or \"No number yet\". Tap \"Save\".",
      "With the decision-maker's number you see \"Promoted to New Leads\".",
      "The calendar icon logs a meeting. It does not promote the lead."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M12-L05",
    "moduleId": "M12",
    "number": 5,
    "title": "Read your field day in Field Sessions",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Field Sessions\".",
      "Tap the date line and pick a day or a range.",
      "Read \"Conversion\": \"Captured\" to \"Promoted\".",
      "Read a card under \"Field days\": distance, sites, meetings, claim pill.",
      "Read the list \"Field leads\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M12-L06",
    "moduleId": "M12",
    "number": 6,
    "title": "Work a captured site: call, photos, directions, add a number",
    "platform": "Android",
    "who": "All sales (add number: own sites only)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In \"Field leads\" tap a site.",
      "Tap \"Call site contact\" or \"Call the owner\".",
      "Tap \"See photos (N)\" or \"Directions\".",
      "Tap \"Add a number\". Fill \"Mobile number\" and \"Whose number is this?\".",
      "Tap \"Save\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M12-L07",
    "moduleId": "M12",
    "number": 7,
    "title": "Promote a site into the pipeline",
    "platform": "Android",
    "who": "Owner of the field data",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open a site at \"Contact Found\".",
      "Tap \"Fill details & promote\".",
      "Fill \"Decision maker's name\" and \"What did they ask about?\".",
      "Tap \"Promote\".",
      "Tap \"Open the lead\". Finding the owner's number alone does not promote the site."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Promote\""
    }
  },
  {
    "id": "M12-L08",
    "moduleId": "M12",
    "number": 8,
    "title": "Log a meeting you held in the field",
    "platform": "Android",
    "who": "Owner of the field data",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Field Sessions tap \"Log a meeting\".",
      "Pick the site under \"Which site?\".",
      "Set \"When\" and \"How long\". Add notes.",
      "Tap \"Log meeting\".",
      "It shows under \"Meetings\" with the badge \"logged\". It does not promote the site."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Log meeting\""
    }
  },
  {
    "id": "M12-L09",
    "moduleId": "M12",
    "number": 9,
    "title": "Claim TA/DA for your field days",
    "platform": "Android",
    "who": "The person who did the day",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On a day card tap \"Claim TA/DA\". For a range tap \"Claim period\".",
      "Read \"Distance\" and \"Computed entitlement\".",
      "Type \"Amount claimed (₹)\". Add notes.",
      "Tap \"Submit claim\". Or \"Skip\" to claim later.",
      "Skipped days show on the card \"Travel not claimed\" → \"Claim\".",
      "The same day can never be claimed twice."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit claim\""
    }
  },
  {
    "id": "M12-L10",
    "moduleId": "M12",
    "number": 10,
    "title": "See your own tracked day (My Activity)",
    "platform": "Android",
    "who": "All sales who are not team-tracking viewers",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"My Activity\".",
      "Tab \"Map\": see \"Start\", the stops and \"Last location\".",
      "Read \"Distance today\" and \"Location gaps\".",
      "Tab \"Timeline\": a red block means \"Not recording\".",
      "Tab \"History\": pick \"Week\", \"Month\" or \"Custom\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M12-L11",
    "moduleId": "M12",
    "number": 11,
    "title": "Follow a route your manager planned",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Meetings\" → \"Route\" → tab \"My Day\".",
      "Read the numbered stops with the address and distance.",
      "Tap the phone icon to call a stop.",
      "At the stop tap \"Mark\". It becomes \"Done\".",
      "Profile → \"Tracking\" → \"Field visits\" also shows each stop as \"Checked in\" or \"Pending\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Mark\""
    }
  },
  {
    "id": "M12-L12",
    "moduleId": "M12",
    "number": 12,
    "title": "Plan a site visit (Visit planner)",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Profile → \"Visit planner\".",
      "Read visits under Today, Tomorrow, This week, Later.",
      "Tap \"Schedule Visit\". Fill \"CONTACT / LEAD *\" and the date. Tap \"Schedule\".",
      "Tap a visit to open the contact page.",
      "There use \"Call\", \"WhatsApp\", \"Email\", \"Directions\".",
      "The map box at the top is only a drawing."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Schedule\""
    }
  },
  {
    "id": "M13-L01",
    "moduleId": "M13",
    "number": 1,
    "title": "Set a meeting with a customer",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Wrap Up tap \"Meeting set\". Or on the lead open \"Meetings\" → \"Set a meeting\".",
      "Pick \"Physical\" or \"Online\".",
      "Pick the date and time.",
      "Physical: tap \"Use lead address\" or type the address. Online: paste the \"Meeting URL\".",
      "Tick \"Manager joins\" to invite your manager.",
      "Tap \"Save meeting\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save meeting\""
    }
  },
  {
    "id": "M13-L02",
    "moduleId": "M13",
    "number": 2,
    "title": "See your meetings",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Meetings\".",
      "Read the tiles \"Today\", \"Upcoming\", \"Needs action\", \"Done · wk\".",
      "In \"Agenda\" tap a card for details.",
      "Use \"Call\", \"Join\", \"Navigate\" or \"Create quote\".",
      "Tap \"Map\" to see today's physical meetings.",
      "Home shows \"MEETINGS YOU'RE INVITED TO\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M13-L03",
    "moduleId": "M13",
    "number": 3,
    "title": "Record what happened in a meeting",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the meeting from the Agenda.",
      "Tap \"Update status\".",
      "Pick \"Completed\", \"No-show\" or \"Cancel\".",
      "This works only while the meeting is \"Scheduled\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "picking a status"
    }
  },
  {
    "id": "M13-L04",
    "moduleId": "M13",
    "number": 4,
    "title": "Work your tasks",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Tasks\".",
      "Read the groups \"OVERDUE\", \"TODAY\", \"THIS WEEK\", \"LATER\".",
      "Tap \"Done\" on a finished task.",
      "Tap \"Postpone\" and pick the new day. The deadline stays.",
      "A task with the chip \"Non-movable\" cannot be postponed.",
      "Tap + to add a task. Switch \"List\" / \"Calendar\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Done\""
    }
  },
  {
    "id": "M13-L05",
    "moduleId": "M13",
    "number": 5,
    "title": "Use the calendar and create a task",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Tasks switch to \"Calendar\".",
      "Dots show tasks, meetings and follow-ups. Tap a date.",
      "Tap \"Open\" on a meeting or follow-up to open the lead.",
      "Tap \"New task\". Fill \"Task title\", \"Priority\", \"Scheduled day\", \"Hard deadline\".",
      "Tap \"Create task\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create task\""
    }
  },
  {
    "id": "M13-L06",
    "moduleId": "M13",
    "number": 6,
    "title": "See your activity and the team's on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Activities\".",
      "Tab \"Personal\": your tasks and \"My week\".",
      "Tab \"Team\": \"Team calls today\", \"Meetings\", \"Site visits\".",
      "Read the table by rep."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L01",
    "moduleId": "M14",
    "number": 1,
    "title": "Apply for leave",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Leave\".",
      "Tap \"Apply for leave\".",
      "Pick the \"TYPE\": \"Casual\", \"Sick\", \"Earned\", \"Unpaid\".",
      "Pick \"FROM\" and \"TO\". Add a reason.",
      "Tap \"Submit request\".",
      "Read the status chip: \"Pending\", \"Approved\", \"Rejected\". A sent request cannot be changed."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit request\""
    }
  },
  {
    "id": "M14-L02",
    "moduleId": "M14",
    "number": 2,
    "title": "See your expense and TA/DA claims",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Expenses & TA/DA\".",
      "Filter \"All\", \"Draft\", \"Submitted\", \"Approved\", \"Rejected\".",
      "Read the status pill on each card.",
      "Tap a claim to read it.",
      "A rejected claim shows \"WHY HR REJECTED THIS\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L03",
    "moduleId": "M14",
    "number": 3,
    "title": "Make an expense claim with a bill",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"New claim\". Type the \"PURPOSE\". Pick the \"DATE\".",
      "Tap \"Add expense line\". Pick the \"TYPE\".",
      "Fill \"DESCRIPTION\" and \"AMOUNT (₹)\".",
      "Tap \"Photograph\" to take the bill photo. Camera only.",
      "For a GST bill open \"Vendor invoice details (GST)\".",
      "Tap \"Add line\". The bin icon removes a line."
    ],
    "minutes": {
      "android": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add line\""
    }
  },
  {
    "id": "M14-L04",
    "moduleId": "M14",
    "number": 4,
    "title": "Add a TA/DA line to a claim",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In \"Add expense line\" pick an allowance type.",
      "Type only \"QUANTITY (DAYS)\" or \"QUANTITY (KMS)\".",
      "The app shows quantity × rate = total. You never type the rate.",
      "If the type \"is not available yet\", ask HR to set your rate."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L05",
    "moduleId": "M14",
    "number": 5,
    "title": "Send a claim to HR, or withdraw a draft",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open the draft claim.",
      "Tap \"Submit to HR\". It needs at least one line.",
      "After that it is read-only.",
      "To drop a draft tap \"Withdraw draft\" → \"Withdraw\". It is deleted for good."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit to HR\""
    }
  },
  {
    "id": "M14-L06",
    "moduleId": "M14",
    "number": 6,
    "title": "Read your own report",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Reports\" (or Home → \"Lead Reports\").",
      "Tap the period chip: \"Today\" → \"This week\" → \"This month\".",
      "Read \"Calls made\", \"Connected\", \"Follow-ups\", \"Converted\".",
      "Tap \"Calls made\" for the last 50 calls. Tap \"Follow-ups\" for the list.",
      "Read \"Current pipeline (all-time)\", \"Call time\" and \"My quota\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L07",
    "moduleId": "M14",
    "number": 7,
    "title": "Read your scorecard",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Profile\" → \"My Scorecard\".",
      "Read your score out of 100 and the change from last period.",
      "Read \"SUMMARY\" and \"YOUR KPIs\" with each weight.",
      "Read \"REP ACTIVITY\" for a time range.",
      "\"Not scored yet\" means no scored activity so far."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L08",
    "moduleId": "M14",
    "number": 8,
    "title": "Read the leaderboard and your rank",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Leaderboard\". Or on Home tap \"YOUR RANK · TODAY\".",
      "Read \"YOUR RANK\".",
      "Switch \"Daily\", \"Weekly\", \"Monthly\".",
      "Read \"TOP 10\". Your row is tagged \"YOU\".",
      "Tap ⓘ beside \"connected\": it means you spoke for more than 20 seconds.",
      "Tap \"My Performance →\" for your detail."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L09",
    "moduleId": "M14",
    "number": 9,
    "title": "How points work",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the Leaderboard open the sheet \"How points work\".",
      "Connected call: +1 each.",
      "Follow-up done on time: +2. \"On time\" means you, or a teammate, call that customer within 24 hours of the follow-up time. Not called in 24 hours: −2. The call that set the follow-up does not count. Cancelled: 0.",
      "Quote: +20. Won: +100. Lost: 0.",
      "Rupees sold: +1 for every full ₹10,000 of confirmed orders.",
      "The Monthly board starts from 0 on the 1st.",
      "The chip \"Milestone · N pts\" on a lead page is a different number. It is the lead's progress, not your points."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L10",
    "moduleId": "M14",
    "number": 10,
    "title": "Your profile, settings and sign out",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → tap your photo to change it: \"Take photo\" / \"Choose from gallery\".",
      "Menu → \"Profile\" → \"Preferences\" → \"Edit profile\". Change name or phone. Tap \"Save\".",
      "\"View full profile\" shows \"Deals\", \"Won (mo)\", \"Quota\".",
      "\"Products\" lets you browse the catalogue.",
      "Menu → \"Settings\" for the version and \"Setup & Permissions\".",
      "\"Sign out\" is separate from wrapping up your day."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Sign out\""
    }
  },
  {
    "id": "M14-L11",
    "moduleId": "M14",
    "number": 11,
    "title": "Report a bug from the app",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Support\" → \"New ticket\".",
      "Under \"WHAT IS THIS?\" pick \"Bug\". (The other choice is \"Feature request\".)",
      "Pick the \"MODULE\" — the part of the app.",
      "Pick the \"SEVERITY\": \"High\", \"Medium\" or \"Low\".",
      "Write the \"SUBJECT\" and the \"DESCRIPTION\": what happened and what you expected.",
      "Under \"PHOTOS (OPTIONAL, MAX 3)\" tap + → \"Take a photo\" or \"Pick from gallery\". Each photo must be under 2 MB.",
      "Tap \"Submit ticket\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit ticket\""
    }
  },
  {
    "id": "M14-L12",
    "moduleId": "M14",
    "number": 12,
    "title": "Make a support ticket from the app and follow it",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Support\" (also Profile → \"Support\"). The screen lists your tickets.",
      "Tap \"New ticket\". Pick \"Bug\" or \"Feature request\". Fill the form and attach photos. Tap \"Submit ticket\".",
      "Back on the list read the status: \"Open\", \"In progress\", \"Waiting on you\", \"Resolved\", \"Closed\".",
      "Tap a ticket. The screen \"Ticket\" shows \"Category\", \"Module\", \"Priority\", \"Assigned to\".",
      "Read the replies under \"CONVERSATION\" and the fix under \"RESOLUTION\".",
      "Type in \"Write a reply…\" and send. \"Waiting on you\" means the team waits for your reply."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit ticket\""
    }
  },
  {
    "id": "M14-L13",
    "moduleId": "M14",
    "number": 13,
    "title": "Update the app",
    "platform": "Android",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "After you start the day a pop-up may say \"Update app — v… available\". Tap \"Update\".",
      "Or Menu → \"Update app\".",
      "If asked, allow \"Allow app updates\" once.",
      "Wait for \"Download verified. Ready to install.\" Tap \"Install\".",
      "\"Update required\" blocks the app until you update. It never interrupts a call."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "installs a real update"
    }
  },
  {
    "id": "M14-L14",
    "moduleId": "M14",
    "number": 14,
    "title": "Read your scorecard on the web",
    "platform": "Web",
    "who": "P01, P02",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"My Scorecard\". The heading is \"My Performance\".",
      "Pick the \"Period\": \"This month\", \"Last month\", \"This quarter\", \"Last quarter\" or \"Custom range\" (From – To).",
      "Read the score, the band and \"Score uses X of Y KPIs\".",
      "Read \"KPI Breakdown\": each KPI with its target, achievement and weight. A KPI that is not scored says why, for example \"No target set — ask admin\".",
      "Click \"How points work\": how each KPI is counted, the score formula and the bands."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L15",
    "moduleId": "M14",
    "number": 15,
    "title": "Your profile and password on the web",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Initials button → \"Profile\".",
      "Click \"Edit Profile\". Change name or phone. Click \"Save Changes\".",
      "Under \"Change Password\" fill the three fields and click \"Change Password\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M14-L16",
    "moduleId": "M14",
    "number": 16,
    "title": "Report a bug from the web",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Initials button → \"Support\".",
      "Click \"New ticket\".",
      "Under \"What is this?\" pick \"Bug\". (The other choice is \"Feature request\".)",
      "Pick \"Module *\" and \"Severity\".",
      "Fill \"Subject *\" and \"Description *\". Attach images.",
      "Click \"Submit\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit\""
    }
  },
  {
    "id": "M14-L17",
    "moduleId": "M14",
    "number": 17,
    "title": "Make a support ticket on the web and follow it",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Initials button → \"Support\".",
      "The page lists the tickets you raised. \"Nothing raised yet\" means none.",
      "Click \"New ticket\". Pick \"Bug\" or \"Feature request\". Fill the form. Click \"Submit\".",
      "Come back to this page to track what you raised."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit\""
    }
  },
  {
    "id": "M14-L18",
    "moduleId": "M14",
    "number": 18,
    "title": "Use the AI helper on the web and know what it costs",
    "platform": "Web",
    "who": "All sales",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "The top bar chip \"AI credits\" shows the company balance.",
      "Click \"⌘J\" to open the AI panel. Each \"Send · 10\" costs 10 credits.",
      "On a lead \"Score (2 credits)\" scores it. \"Score All\" scores every lead.",
      "On a contact: \"Score Lead\" 2, \"AI Email\" 3, AI suggestions 1.",
      "Use AI only when you need it. Credits are shared."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M15-L01",
    "moduleId": "M15",
    "number": 1,
    "title": "Rules: what a coordinator may do for her manager",
    "platform": "Both",
    "who": "Coordinator",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "You work for one manager: your reporting manager. There is no manager picker.",
      "You have no dealers of your own. Every dealer step is for your manager. The screen says \"Working for manager\".",
      "You may add and edit his dealers, work his prospects, appoint, and mark his dealer proposal won.",
      "You may enter bank details. You can never see the saved account number.",
      "When you work for him, HIS discount limits apply.",
      "You can see the discount inbox. You cannot approve, reject or escalate.",
      "If no manager is set you see \"Not available\". Ask your admin."
    ],
    "minutes": {
      "android": 2,
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M15-L02",
    "moduleId": "M15",
    "number": 2,
    "title": "Create a lead, quote or sale for your manager",
    "platform": "Android",
    "who": "Coordinator",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Normal Lead form: turn on \"Create this lead for Manager\". The button reads \"Save lead for Manager\".",
      "Quick Quote: turn on \"Quote for manager\".",
      "Quick Sale: turn on \"Book for manager\". The button reads \"Take order for manager\".",
      "With a dealer chosen the switch turns ON and locks.",
      "The manager becomes the owner. You stay on record as the creator."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L03",
    "moduleId": "M15",
    "number": 3,
    "title": "Switch between your own leads and your team's",
    "platform": "Android",
    "who": "Coordinator",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads use the toggle \"Individual\" / \"My Team\".",
      "The same toggle is on the Assignment queue.",
      "\"My Team\" does not include unassigned leads."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L04",
    "moduleId": "M15",
    "number": 4,
    "title": "Track discount requests for your manager",
    "platform": "Android",
    "who": "Coordinator",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Discount Approvals\".",
      "You see the same inbox with no approve buttons.",
      "Read the labels \"With manager (name)\", \"With MD\", \"Escalated to MD\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L05",
    "moduleId": "M15",
    "number": 5,
    "title": "Give a follow-up to someone else",
    "platform": "Android",
    "who": "Coordinator (to her manager); managers (to their team)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Follow-ups tap \"+\". Pick the lead from the list, or search for it.",
      "In \"Schedule follow-up\" open \"Assign to\".",
      "Pick the person, for example your manager. Pick date and time. Tap \"Schedule\".",
      "To give it to someone else, the lead needs a linked contact. If it has none, assign the follow-up to yourself."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Schedule\""
    }
  },
  {
    "id": "M16-L01",
    "moduleId": "M16",
    "number": 1,
    "title": "Read the team block on Home and the team day report",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Scroll Home to \"TEAM OVERVIEW\".",
      "Read \"TEAM PIPELINE\", \"Team attendance\", \"Team won (MTD)\", \"Discount approvals\".",
      "After you wrap up, in \"Day-End Summary\" tap \"Team report\".",
      "Tap \"Download team PDF\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L02",
    "moduleId": "M16",
    "number": 2,
    "title": "See your team's leads, proposals and orders",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads tap the owner chip. In \"Show leads owned by\" pick a member, yourself or everyone.",
      "The owner pill under a row shows who owns it.",
      "Tap \"History\" under a row to read the lead's full timeline.",
      "The same owner chip is on the Assignment queue and Field Sessions.",
      "In \"Sales & Orders\" switch \"Individual\" / \"My Team\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L03",
    "moduleId": "M16",
    "number": 3,
    "title": "Assign a lead to a team member",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Assign\".",
      "Pick the member under \"Assign to team member\".",
      "Add a note and a follow-up time.",
      "Tap \"Assign lead\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Assign lead\""
    }
  },
  {
    "id": "M16-L04",
    "moduleId": "M16",
    "number": 4,
    "title": "Assign a lead to a dealer and claim it back",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap \"Assign\" and switch to \"Dealer\".",
      "In \"Assign to dealer\" pick one of your dealers. Tap \"Assign to dealer\".",
      "To take it back tap \"Claim back from dealer\" → \"Claim back\".",
      "The lead returns to you."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Assign to dealer\""
    }
  },
  {
    "id": "M16-L05",
    "moduleId": "M16",
    "number": 5,
    "title": "Approve or decline lead access requests",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Access Requests\".",
      "Read the name-match badge: \"Likely typo\", \"Names differ\", \"No name given\".",
      "Tap \"Approve\". The lead is reassigned to the requester.",
      "Or tap \"Decline\" and add a reason.",
      "Under \"Claim requests · N\" tap ✓ or ✕."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Approve\""
    }
  },
  {
    "id": "M16-L06",
    "moduleId": "M16",
    "number": 6,
    "title": "Read the discount approvals inbox",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Discount Approvals\".",
      "Tabs: \"Pending\", \"Approved\", \"Rejected\".",
      "Switch \"Waiting for you (N)\" / \"With MD (N)\".",
      "Read a card: \"REQUESTED\", \"POLICY\", \"IMPACT\", \"Your cap\".",
      "A dealer request shows \"Through dealer\" with the margin.",
      "Tap \"Info\" for the details."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L07",
    "moduleId": "M16",
    "number": 7,
    "title": "Approve, reject or escalate a discount",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Tap \"Approve\" → confirm.",
      "Above your cap tap \"Approve at max\", or \"Escalate\".",
      "Tap \"Reject\" and add a reason.",
      "Each line is decided on its own. The document stays held until all lines are approved.",
      "Then use \"Download proposal\" or \"Convert SO\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M16-L08",
    "moduleId": "M16",
    "number": 8,
    "title": "Confirm a payment, mark Won on credit, or continue without payment",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the convert sheet tap \"Confirm payment & mark Won\". The deal is Won at once.",
      "\"Skip proof (manager only)\" converts without a screenshot.",
      "\"Mark Won on credit (no payment)\" keeps the amount receivable.",
      "In \"Record payment\" the button records and confirms at once.",
      "On your own order \"Continue without payment\" marks Won. The amount stays due.",
      "If the lead still has a follow-up, \"Sale marked Won\" asks \"Mark that follow-up as done?\". Tap \"Mark done\" or \"Keep it\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M16-L09",
    "moduleId": "M16",
    "number": 9,
    "title": "Rename a lead, change the customer type, block a contact",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On the lead tap the pencil beside the name → \"Rename lead\" → \"Save\".",
      "Tap \"CUSTOMER TYPE\" and pick \"B2C (Individual)\", \"B2B (Business)\" or \"Project\".",
      "On a contact page ⋮ → \"Mark DND\", pick the reason, tap \"Mark\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M16-L10",
    "moduleId": "M16",
    "number": 10,
    "title": "Force a call on a locked Sprint lead",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the Sprint runner a locked lead shows \"LOCKED\".",
      "Tap \"Force call\".",
      "It is never offered on a DND lead."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "dials a real lead"
    }
  },
  {
    "id": "M16-L11",
    "moduleId": "M16",
    "number": 11,
    "title": "Team screen: leaderboard and live activity",
    "platform": "Android",
    "who": "Team heads",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Team\".",
      "Tab \"LEADERBOARD\": pick \"TODAY\", \"THIS WEEK\", \"THIS MONTH\" and sort.",
      "Tap a rep for \"Performance\".",
      "Tab \"ACTIVITY\": tap a row to open the lead.",
      "On the Leaderboard screen you can open any person's detail."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L12",
    "moduleId": "M16",
    "number": 12,
    "title": "Team pipeline, team activity and team locations",
    "platform": "Android",
    "who": "Manager only",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Profile\" → TEAM.",
      "\"Team pipeline\": totals and \"Stage breakdown\".",
      "\"Team quota\": calls, connect % and \"Rep ranking\".",
      "\"Team locations · map\": tap a pin for \"Last ping\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L13",
    "moduleId": "M16",
    "number": 13,
    "title": "Team Tracking: who is in the field",
    "platform": "Android",
    "who": "Team-tracking roles",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Menu → \"Team Tracking\".",
      "Read \"In field now\", \"Team distance\", \"Not recording\", \"Location off\".",
      "Read each person's status and chips.",
      "Tap \"Remind again\" on a person who is not recording. Once per 15 minutes.",
      "Tap a card to open that person's day."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Remind again\""
    }
  },
  {
    "id": "M16-L14",
    "moduleId": "M16",
    "number": 14,
    "title": "Team map: everyone's routes",
    "platform": "Android",
    "who": "Team-tracking roles",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Team Tracking tap \"⤢ Full map\".",
      "Filter \"All\", \"Moving\", \"Stopped\", \"Off\".",
      "Tap a person card → \"Open name's day →\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M16-L15",
    "moduleId": "M16",
    "number": 15,
    "title": "Team meetings and planning a rep's route",
    "platform": "Android",
    "who": "Managers in the meetings list",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In Meetings switch \"Individual\" / \"My Team\" / \"All\".",
      "Tap the chip \"Invitations\".",
      "\"Route\" → \"Plan\": pick the date and \"Assign to…\".",
      "Tap pins on the map. Tap \"Save field day\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save field day\""
    }
  },
  {
    "id": "M16-L16",
    "moduleId": "M16",
    "number": 16,
    "title": "Give a task to a team member and lock its day",
    "platform": "Android",
    "who": "Team heads",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In \"New task\" open \"Assign to\" and pick the member.",
      "Turn on \"Non-movable\" to lock the scheduled day.",
      "Tap \"Assign task\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Assign task\""
    }
  },
  {
    "id": "M16-L17",
    "moduleId": "M16",
    "number": 17,
    "title": "Team and Org scorecards",
    "platform": "Android",
    "who": "Team leads; leadership for Org",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Profile → \"Team Scorecard\".",
      "Under \"TEAM SCORES\" tap a person.",
      "Profile → \"Org Scorecard\" is for leadership only."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L01",
    "moduleId": "M17",
    "number": 1,
    "title": "Read the \"Team Sales\" dashboard",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Dashboard\". The heading is \"Team Sales\".",
      "Click a number card: \"Team pipeline\", \"Won this month\", \"Conversion\", \"Overdue follow-ups\", \"Waiting for you\".",
      "Read \"Pipeline by stage\" (\"without an open quote\") and \"Rep performance\": \"Open leads\", won, target or \"Not set up\".",
      "Under \"Approvals waiting\" click \"Review request\".",
      "Read the five oldest \"Overdue follow-ups\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L02",
    "moduleId": "M17",
    "number": 2,
    "title": "Team Scorecards",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Team Scorecards\".",
      "Pick the \"Period\".",
      "Read \"Team avg\" and the band tiles. Each person is scored on the KPIs of their own role.",
      "Sort the table by score.",
      "Click \"How points work\" under a name, or click the name to open that scorecard."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L03",
    "moduleId": "M17",
    "number": 3,
    "title": "Pipeline board (read-only)",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Pipeline\".",
      "\"Kanban\" shows the columns by stage.",
      "\"Stage × Temperature\" shows a count table.",
      "It is read-only."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L04",
    "moduleId": "M17",
    "number": 4,
    "title": "Sales Targets and the target preview",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Sales Targets\".",
      "Pick \"Manager\", \"Fiscal Year\", \"Monthly\" or \"Quarterly\", and \"Period\".",
      "Read the table per product group: \"Target Litres\" and \"Target ₹\".",
      "In \"Target Preview\" click \"Preview\": \"Overall Attainment\" and each product's attainment.",
      "Targets are view-only for you."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L05",
    "moduleId": "M17",
    "number": 5,
    "title": "Filter leads by owner and reassign a lead",
    "platform": "Web",
    "who": "P01 (server decides)",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On Leads click \"Filters\" → \"Assigned User\" and pick a person.",
      "✕ on the owner chip removes the filter.",
      "In the row use the Assigned dropdown to hand the lead over.",
      "Or use \"Assigned To\" in the panel."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "reassigning"
    }
  },
  {
    "id": "M17-L06",
    "moduleId": "M17",
    "number": 6,
    "title": "Manage the team's follow-ups",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Follow-ups\" under Team.",
      "Read \"Due today\", \"Overdue\", \"Completed (7d)\".",
      "Filter by \"Rep\", \"Status\", \"Stage\", dates, or \"Overdue only\".",
      "On a PENDING row click \"Reassign\", ✓ or ✕. ✓ opens the same \"Mark follow-up done\" box: pick the call or how it went, then \"Save & mark done\".",
      "Click \"Refresh\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "a row action"
    }
  },
  {
    "id": "M17-L07",
    "moduleId": "M17",
    "number": 7,
    "title": "Approve, reject or escalate discount requests",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Discount Approvals\".",
      "Click \"Approve\", add remarks, click \"Confirm Approve\".",
      "Or click \"Reject\" → \"Confirm Reject\".",
      "Beyond your slab click \"Escalate\". After that you cannot decide it.",
      "\"Approve all N at requested %\" approves every line of one document.",
      "When all lines are approved use \"Convert SO\" or \"Download proposal\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirm"
    }
  },
  {
    "id": "M17-L08",
    "moduleId": "M17",
    "number": 8,
    "title": "Reps: team leaderboard and your own numbers",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Reps\" and pick the \"Period\".",
      "Tab \"Team\": open leads, won, quota (or \"No quota set\"), calls made and score per rep.",
      "Tab \"Personal\": \"Quota attainment\", \"Open pipeline (now)\", \"Closed won (period)\", \"Activity score\".",
      "Read \"Activity · weekly trend\": calls made, meetings held, site visits."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L09",
    "moduleId": "M17",
    "number": 9,
    "title": "Schedule and manage team meetings",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Meetings\". Read the four tiles.",
      "Pick \"My meetings\", \"My team\" or \"All\". Filter by status.",
      "Click \"Schedule meeting\", fill the form, click \"Schedule meeting\".",
      "On a row click \"Reschedule / close\", set \"Status\", click \"Save changes\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M17-L10",
    "moduleId": "M17",
    "number": 10,
    "title": "Team Tracking: live positions and a rep's day trail",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Team Tracking\".",
      "Tab \"Live\": pins and the list.",
      "Tab \"Day Trail\": pick the rep and the date.",
      "Click a ping to focus the map.",
      "Click \"Refresh\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L11",
    "moduleId": "M17",
    "number": 11,
    "title": "Set a rep's allowed zone (geofence) and see breaches",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "In the Live list click \"Add fence\" or \"Edit fence\".",
      "Click on the map to set the centre.",
      "Type the label and the radius. Save.",
      "Read \"Recent geofence breaches\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M17-L12",
    "moduleId": "M17",
    "number": 12,
    "title": "Read the team's attendance",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "Open \"Attendance\".",
      "Read \"Present today\", \"Absent today\", \"Not checked in today\".",
      "Read the month grid. A marked cell is an override."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L13",
    "moduleId": "M17",
    "number": 13,
    "title": "Set a dealer's discount slabs",
    "platform": "Web",
    "who": "P01 (when switched on)",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"My dealers\" click \"Slabs\" on the dealer.",
      "Set the auto-approve and max-approve % for each category.",
      "They are capped at your own margin.",
      "Save."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M17-L14",
    "moduleId": "M17",
    "number": 14,
    "title": "Reassign many leads at once",
    "platform": "Web",
    "who": "P01",
    "managerOnly": true,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": false,
    "steps": [
      "On \"Leads\" tick the box on each row, or the box at the top to select every lead on this page.",
      "The bar shows how many are selected and whose they are. Click \"Reassign to…\".",
      "Pick the \"New owner\". Keep \"Move their pending follow-ups too\" ticked.",
      "Type the \"Reason\". It is saved in each lead's history.",
      "Read which leads will be skipped: with a dealer, won, lost, duplicates, dealer prospects.",
      "Click \"Reassign N leads\". \"Undo\" stays for 10 seconds; \"See skipped\" lists the rest."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "reassigning"
    }
  },
  {
    "id": "M18-L01",
    "moduleId": "M18",
    "number": 1,
    "title": "Download the mobile apps",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "On \"People Desk\" read the \"Mobile apps\" box under the approval queues, or open \"Apps & Training\" → \"Mobile Apps\".",
      "Each card shows the app, its version and \"FORCED\" when phones must update.",
      "Click \"Download\" to get the app file.",
      "Click \"Copy link\" to send the link to an employee.",
      "Click \"QR\" and let the employee scan it with the phone camera."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L02",
    "moduleId": "M18",
    "number": 2,
    "title": "Track App Tour progress",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "On \"People Desk\" read the \"App Tour progress\" box, or open \"Apps & Training\" → \"App Tour Progress\".",
      "Read \"App Tour totals\".",
      "Filter by role and team.",
      "Read each person's \"Phone tour\" and \"Web tour\" — \"No tour\" when their app has none — then \"Last watched\" and their own \"App\" version.",
      "Click \"Download as Excel\" for what is shown."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L03",
    "moduleId": "M18",
    "number": 3,
    "title": "Start your day on the People Desk",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Dashboard\" in the left menu. The \"People Desk\" opens.",
      "Read the boxes \"Present today\" (punched in on the app, with how many staff are not on the punch app), \"On leave\", \"Expense claims\", \"Payroll lock\" and \"Open roles\". Click one to open its page.",
      "In \"Leave requests\" click \"Approve\" or \"Reject\", then \"Confirm decision\".",
      "\"Expense claims\" lists submitted claims. Check the bills on \"Expense Approvals\" before approving.",
      "On the right read \"Attendance exceptions\" and \"Hiring\".",
      "Under the queues read \"App Tour progress\" and \"Mobile apps\".",
      "Use \"Add employee\" and \"Run attendance\" at the top."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L04",
    "moduleId": "M18",
    "number": 4,
    "title": "Add a new employee",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Open \"People\" and click \"Add Employee\".",
      "On \"Identity & Login\" type \"First name\", \"Last name\", \"Login email\" and \"Temporary password\".",
      "Pick the \"Department\" first. It decides the \"Login role\". Then pick the \"Position\".",
      "Add \"Phone\", \"Date of joining\" and \"Monthly salary (₹)\". Click \"Next\".",
      "Fill \"Personal & KYC\", \"Bank & Address\" and \"Vehicle\" as far as you can. Click \"Next\".",
      "On \"Documents & Review\" attach documents, check the summary and click \"Create employee\".",
      "The new employee shows in the list with \"Login on\". Give them the email and temporary password."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "real save"
    }
  },
  {
    "id": "M18-L05",
    "moduleId": "M18",
    "number": 5,
    "title": "Find and edit an employee",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "On \"People\" type a name in \"Search employees...\". \"Active\", \"Past\" and \"All\" pick who is listed.",
      "Click the pencil on the row.",
      "\"Edit employee\" opens. Leave \"Reset password\" blank to keep the password.",
      "Change what is needed, for example \"Phone\".",
      "Click any tab to jump to it, for example \"Bank & Address\".",
      "Click \"Next\" to \"Documents & Review\" and click \"Save changes\". \"History\" keeps every change."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "real save"
    }
  },
  {
    "id": "M18-L06",
    "moduleId": "M18",
    "number": 6,
    "title": "Run attendance for the month",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Run attendance\" on the People Desk, or \"Attendance\" in the left menu.",
      "Read \"Present today\" (punched in on the app), \"Absent today\", \"Avg hours / employee\", \"Overrides this month\" and \"Not checked in today\".",
      "The yellow box \"Not checked in today\" names everyone who has not punched in.",
      "Read the month grid: one row per person, one box per day. \"A\" absent, \"IN\" punched in, hours on a present day.",
      "Colours: \"Present (hours)\", \"Half day\", \"Absent\", \"Punched in\", \"Override\".",
      "Use the arrows at the top for another month."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L07",
    "moduleId": "M18",
    "number": 7,
    "title": "Fix a day: punches and HR override",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "On \"Attendance\" click the box for the person and the day.",
      "Read \"Punch sessions\": each punch in and punch out that day.",
      "Read \"Day rollup\": the day's status and hours.",
      "Under \"Override\" pick \"Status\", type \"Hours (optional)\" and write \"Note *\".",
      "Click \"Save override\".",
      "The box shows the hours and an orange \"Override\" dot. The drawer says who changed it, when and why."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save override\""
    }
  },
  {
    "id": "M18-L08",
    "moduleId": "M18",
    "number": 8,
    "title": "See where the field team is",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Team Tracking\" in the left menu.",
      "On \"Live\" read the map pins and \"Active today\": last seen and pings per person.",
      "Click \"Day Trail\", then pick the person and the date.",
      "\"Locations\" lists that day's pings, earliest first. Click one to move the map there.",
      "Click \"Refresh\" for the newest positions."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L09",
    "moduleId": "M18",
    "number": 9,
    "title": "Approve or reject leave",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Leave\" in the left menu.",
      "Read each request: employee, type, dates, days, reason and status.",
      "Use \"All Statuses\" to show only pending, approved or rejected.",
      "On a \"Pending\" request click the tick to approve or the cross to reject.",
      "The status changes at once.",
      "To add leave for someone click \"New Leave Request\", fill it and click \"Submit Request\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "the tick"
    }
  },
  {
    "id": "M18-L10",
    "moduleId": "M18",
    "number": 10,
    "title": "Review bills, edit amounts and approve an expense",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Expense Approvals\" in the left menu.",
      "\"Approval queue\" lists submitted claims. \"Approved\", \"Rejected\" and \"All\" show older ones.",
      "Click \"Review\". Each line shows what was claimed, where it settles and the bill under \"Receipt\".",
      "To pass less, type the amount in \"Sanctioned\" (never more than claimed) and write why in the approval note.",
      "Click \"Approve\", or \"Reject\" with a reason.",
      "Under \"Approved\" the claim shows the sanctioned amount.",
      "\"Allowance rates\" holds each employee's DA and TA rate per day."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Approve\""
    }
  },
  {
    "id": "M18-L11",
    "moduleId": "M18",
    "number": 11,
    "title": "Run the monthly payroll",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "\"Payroll\" has six tabs. Work left to right: \"Structures\", \"Assignments\", \"Periods\", \"Runs\", \"Slips\".",
      "\"Structures\" → \"+ New structure\": name, frequency, from date → \"Create structure\". Once.",
      "\"Assignments\" → \"+ Assign salary\": employee, structure, \"Monthly gross (₹)\".",
      "Click \"Save assignment\". Everyone to be paid needs one.",
      "\"Periods\" → \"+ New period\" (month and fiscal year filled in) → \"Create period\".",
      "\"Runs\" → \"+ New run\": check period, name, posting date → \"Create draft run\".",
      "Click \"Run payroll\", check the count, then \"Pay N employee(s)\". A run cannot be undone.",
      "\"Slips\" shows each slip: pay days, gross, TDS, net."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": false,
      "reason": "real payroll run"
    }
  },
  {
    "id": "M18-L12",
    "moduleId": "M18",
    "number": 12,
    "title": "Read the sales team's incentives",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Incentives\" in the left menu.",
      "Read \"Total Team Incentive\", \"Best Performer\", \"Avg Target Achievement\" and \"Total Closures\".",
      "The chips: \"Qualified lead\", \"Meeting held\" and \"Closure (won lead)\" read \"Not set up\" — there is no per-activity incentive. The only live reward is the \"Over-target bonus\" on a target line that has a bonus rate.",
      "Each row is one salesperson: qualified leads (assigned to them or added by them), meetings held and closures (won leads) as plain counts, the \"Over-target bonus\", \"Total ₹\", \"Target (this month)\" and \"Target % · Status\". With no target it says \"No target set\" and \"Not set up\".",
      "Click the arrow (\"Show counted items\") to see each lead, meeting and win that was counted.",
      "Click a name to open that person's report card for the same month.",
      "Pick another month at the top right."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L13",
    "moduleId": "M18",
    "number": 13,
    "title": "Move applicants through the hiring stages",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Recruitment\" in the left menu.",
      "Each card is one job opening. Click \"Open\" on the job.",
      "Open \"Applicants\". The counts on top show applied, screening, interview, offer and joined.",
      "Each row shows the applicant, phone, stage and source.",
      "Click \"Interview\" to set \"Date & time\", \"Mode\" and \"Notes\". \"Save interview\" moves the applicant to interview.",
      "The blue button moves an applicant to the next stage.",
      "Click \"Reject\" for an applicant who is not a fit."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L14",
    "moduleId": "M18",
    "number": 14,
    "title": "Create a job opening with its JD",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Open \"Hiring\" → \"Recruitment\" and click \"New opening\".",
      "Fill \"Job title\", \"Location\", \"Vacancies\", type, salary and experience.",
      "In \"Job description (JD)\" fill all 4 parts: \"About the role\", \"What you will do\", \"Who we are looking for\", \"What we offer\". \"Draft with AI\" writes a first version from the title; read and edit it. \"Upload JD (PDF/Word)\" attaches your own file.",
      "\"Save draft\" keeps it off the careers page. \"Save & publish\" puts it on the careers page — it works only when all 4 parts are filled.",
      "The card shows \"On careers page\" or \"Draft\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false
    }
  },
  {
    "id": "M18-L15",
    "moduleId": "M18",
    "number": 15,
    "title": "Post a job to LinkedIn, Indeed, Naukri and WhatsApp",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "On \"Recruitment\" click \"Open\" on a job, then the \"Post to channels\" tab.",
      "Each channel has its own tracked apply link, so every applicant is tagged with where they came from.",
      "LinkedIn, Indeed, Naukri: click \"Copy post text\", then \"Open <site>\", paste it into their \"post a job\" form, then click \"Mark posted\". Your name and the date are saved.",
      "WhatsApp: \"Share on WhatsApp\" opens your WhatsApp with the text and link.",
      "Google Jobs is automatic from the careers page.",
      "The \"Send log\" tab lists every post and send with how many applied."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false
    }
  },
  {
    "id": "M18-L16",
    "moduleId": "M18",
    "number": 16,
    "title": "Local partners: add a partner and send openings",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Open \"Hiring\" → \"Local partners\" (or \"Send to partners\" on a job's channels tab).",
      "Read the totals: partners, openings sent in 30 days, candidates from partners, joined.",
      "Click \"Add partner\": name, WhatsApp number, area, notes, then \"Save partner\".",
      "Click \"Send openings\", tick the jobs, edit the message if you want, then \"Open WhatsApp & save to log\". It opens your own WhatsApp with the partner's own link.",
      "\"History\" shows what was sent and when. Candidates who apply through that link are counted against the partner."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false
    }
  },
  {
    "id": "M18-L17",
    "moduleId": "M18",
    "number": 17,
    "title": "The careers page and where applicants came from",
    "platform": "Web",
    "who": "HR and admin",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": true,
    "triageOnly": false,
    "steps": [
      "Click \"Careers page\" on Recruitment. It opens your public jobs page; anyone can open it without a login.",
      "Open a job: it shows the full JD, \"Apply for this job\" and \"Share on WhatsApp\".",
      "The apply form asks for name, 10-digit mobile, city and an optional resume. The same mobile cannot apply twice for one job.",
      "Back on the job, open \"Applicants\": the boxes count applicants by source, and each applicant has a source pill such as \"Partner · <name>\" or \"Naukri\".",
      "Click \"Resume\" to open the resume an applicant uploaded."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false
    }
  },
  {
    "id": "M19-L01",
    "moduleId": "M19",
    "number": 1,
    "title": "Find your way around the Lead Triage desk",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Your left menu has \"Lead Triage\", \"Dealers\", \"Prospect dealers\", \"Lead Ops\", \"Profile\" and \"App Tour\".",
      "\"Lead Triage\" opens the \"Lead Triage Dashboard\". \"+ New lead\" is at the top right.",
      "Read the boxes \"Unassigned\", \"Older than 2 h\", \"Verified today\", \"Assigned today\" and \"Dealers without manager\". Click one to open its list.",
      "At the bottom read \"Team load (open leads)\", \"Returned by reps\" and \"Dealers without a manager\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "no guided walk yet"
    }
  },
  {
    "id": "M19-L02",
    "moduleId": "M19",
    "number": 2,
    "title": "Work the queue: tabs, search and filters",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "The desk opens on the tab \"Unassigned\". Other tabs: \"Assigned\", \"Self-made\", \"B2B\", \"Dealer assigned\".",
      "Type in \"Search by name, phone, or email...\".",
      "Pick a date range, or click a source chip \"WEBSITE\", \"INDIAMART\" or \"AI CHATBOX\".",
      "Use \"Verified: any\", \"Tier: any\" and \"Line\" to narrow the list.",
      "Sort with \"Latest reply\" or \"Score\". \"More ▾\" adds Application, Segment, Location and Verified by. \"Clear all\" resets.",
      "Change \"Rows per page\", or use Prev and Next."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "no guided walk yet"
    }
  },
  {
    "id": "M19-L03",
    "moduleId": "M19",
    "number": 3,
    "title": "Read a lead row: score, tier and Avika's answers",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Each row shows the enquiry date, source, name, phone, city, requirement, application, line, capacity, timeline and price shared.",
      "\"Lead Score\" and \"Tier\" (HOT, WARM, COLD) come from Avika's WhatsApp chat.",
      "Click \"Responses\". \"Avika responses\" opens.",
      "Read the \"WhatsApp transcript\" and the \"Captured fields\".",
      "\"Score breakdown\" shows how many points each answer gave.",
      "\"Copy\" copies a short lead summary to send on."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "no guided walk yet"
    }
  },
  {
    "id": "M19-L04",
    "moduleId": "M19",
    "number": 4,
    "title": "Assign the overdue HOT leads first",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Click the tab \"🔥 Overdue HOT\". The red number is how many are waiting.",
      "Read \"Not called within … working hours. Assign now.\"",
      "Each row shows how long the lead has waited.",
      "Click \"Assign to ▾\" and pick a rep. The lead leaves this list."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "assigns a lead"
    }
  },
  {
    "id": "M19-L05",
    "moduleId": "M19",
    "number": 5,
    "title": "Assign a lead to a rep",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Unassigned\" click \"Assign to ▾\" on the row.",
      "\"Assign lead\" opens. Type in \"Search by name, team or dealer…\".",
      "Under \"People\" each rep shows the team and how many HOT leads are ticking.",
      "Click the rep. \"Assigned to …\" confirms it, and the lead moves to the tab \"Assigned\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "assigns a lead"
    }
  },
  {
    "id": "M19-L06",
    "moduleId": "M19",
    "number": 6,
    "title": "Reassign a lead, and leads returned by reps",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On the tab \"Assigned\" the row shows the owner with a lock. Click \"Reassign\".",
      "Pick the new rep. Read \"Reassign … to …?\" and click \"Confirm reassign\".",
      "\"Returned by reps\" at the bottom of the desk lists leads a rep gave back.",
      "Click one. The desk opens it on \"Assigned\" so you can reassign it."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "reassigns a lead"
    }
  },
  {
    "id": "M19-L07",
    "moduleId": "M19",
    "number": 7,
    "title": "Give a lead to a dealer and mark it sent",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Click \"Assign to ▾\" and scroll to \"Dealers\". Dealers are grouped by their manager.",
      "\"Assigning a dealer is in addition to the rep.\" Click the dealer.",
      "Open the tab \"Dealer assigned\". \"Dealer status\" reads \"Not sent\".",
      "After you send the lead to the dealer, click \"✓ Mark as sent\". It reads \"✓ Sent\" with the time and your name."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "assigns a lead"
    }
  },
  {
    "id": "M19-L08",
    "moduleId": "M19",
    "number": 8,
    "title": "Verify a lead by hand",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On an unverified row click \"Verify\". \"Verify lead manually\" opens.",
      "Call the customer and ask the same questions Avika asks.",
      "Fill the answers. A \"*\" marks the ones needed to verify the lead.",
      "Click \"Mark verified\". With every \"*\" filled the row shows \"Manual\" and your name.",
      "If something is missing, the message says \"Answers saved … still needed: …\". Call again later."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a lead"
    }
  },
  {
    "id": "M19-L09",
    "moduleId": "M19",
    "number": 9,
    "title": "Mark a lead as irrelevant",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Unassigned\" click \"Mark as irrelevant\" on a junk or test lead.",
      "Read \"Mark \"…\" as irrelevant?\".",
      "Click \"Mark irrelevant\". The lead leaves the queue.",
      "This is final. There is no undo, so check the name and number first."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "closes a lead"
    }
  },
  {
    "id": "M19-L10",
    "moduleId": "M19",
    "number": 10,
    "title": "Add a new lead from a call or walk-in",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Click \"+ New lead\".",
      "Type \"Mobile number *\". AURA checks it at once.",
      "If \"This number already has a lead\" shows, click \"Open existing lead\" instead.",
      "Type \"Customer name *\", pick State and City, and \"Product interest\".",
      "Pick \"Source *\": \"Phone-in\", \"Walk-in\" or \"Reference\". Click \"Add lead\".",
      "The lead lands on \"Unassigned\", ready to assign."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a lead"
    }
  },
  {
    "id": "M19-L11",
    "moduleId": "M19",
    "number": 11,
    "title": "Fix a name, and see self-made leads",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Point at a customer name and click \"✎\". Type the right name and press Enter.",
      "\"Name updated to …\" confirms it.",
      "Open the tab \"Self-made\". These are leads reps added themselves.",
      "\"Created By\" shows who added each one."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a lead"
    }
  },
  {
    "id": "M19-L12",
    "moduleId": "M19",
    "number": 12,
    "title": "Give a dealer an owner",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Click \"Dealers\" in the left menu. Search with \"Search dealers\".",
      "The column \"Owner\" shows \"No owner\" for a dealer without a manager.",
      "Click \"Assign owner\". The dealer's details are read only.",
      "Pick the manager in \"Choose an owner\" and click \"Save owner\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a dealer"
    }
  },
  {
    "id": "M19-L13",
    "moduleId": "M19",
    "number": 13,
    "title": "Read prospect dealers and Lead Ops",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Click \"Prospect dealers\". Read the boxes, then search or filter by state, fit and follow-up.",
      "Click a shop to read its details. For you this list is read only.",
      "Click \"Lead Ops\". It is a read-only view of the desk.",
      "Read \"Routing-QA Queue\", \"Avika Follow-ups\" and \"Cold Archive\".",
      "Click \"Export CSV\" to download the cold leads."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M19-L14",
    "moduleId": "M19",
    "number": 14,
    "title": "Send a lead to its dealer on WhatsApp and mark it sent",
    "platform": "Web",
    "who": "Lead triage (web)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Open the tab \"Dealer assigned\". A new dealer lead reads \"Not sent\".",
      "Click \"WhatsApp ↗\" under it. \"Send lead to <dealer>\" opens.",
      "Under \"SEND TO\" pick the dealer's contact, or \"Another number…\".",
      "Read the message: every detail of the lead and what Avika collected. Edit it if needed.",
      "Click \"Open WhatsApp ↗\". WhatsApp opens in a new tab with the message; you send it yourself.",
      "Back in AURA answer \"Did you send it?\": click \"✓ Mark as sent\". The row reads \"✓ Sent\" with the time and your name."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "opens WhatsApp"
    }
  },
  {
    "id": "M20-L01",
    "moduleId": "M20",
    "number": 1,
    "title": "Find your way around the Triage app",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "The bottom bar has \"Triage\", \"Calls\", the orange phone button, \"Requests\" and \"Reports\".",
      "Tap the menu icon at the top left for the drawer.",
      "The drawer has \"Follow-ups\", \"Tasks\", \"Profile\", \"Leave\", \"Support\", \"App Tour\" and more.",
      "The bell at the top of the drawer opens your notifications."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "no guided walk yet"
    }
  },
  {
    "id": "M20-L02",
    "moduleId": "M20",
    "number": 2,
    "title": "Start your day and read your numbers",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Triage\" tap \"Start my day\" on the punch card.",
      "Read \"Called\", \"Verified\" and \"Junk rate\" for today.",
      "Tap \"Reports\" for \"My triage numbers\". Switch \"Today\", \"7 days\" and \"30 days\".",
      "Read \"Called\", \"Verified\", \"Junk\", \"Qualified\" and \"Dropped out\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "starts the real day"
    }
  },
  {
    "id": "M20-L03",
    "moduleId": "M20",
    "number": 3,
    "title": "Work the incoming leads",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Triage\" read \"⚡ INCOMING THIS WEEK\". Tap \"View all\" for the full list.",
      "The chips \"Fresh\", \"Avika live\", \"No reply\" and \"Ready\" sort leads by where they are.",
      "If Avika is still chatting, the app asks \"Avika is mid-conversation\". Tap \"Wait\", or \"Call anyway\".",
      "Tap \"Assign\" on a lead to give it to a rep."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "assigns a lead"
    }
  },
  {
    "id": "M20-L04",
    "moduleId": "M20",
    "number": 4,
    "title": "Assign a lead to a rep or a dealer",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Tap \"Assign\" on a lead. \"Assign lead\" opens with Avika's chat.",
      "Tap \"Choose owner\". Pick \"People\" or \"Dealers\".",
      "Search and tap the rep or the dealer.",
      "\"Assigned · removed from your queue\" confirms it."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "assigns a lead"
    }
  },
  {
    "id": "M20-L05",
    "moduleId": "M20",
    "number": 5,
    "title": "Find any lead",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Triage\" tap \"Search any lead — name, company or phone\".",
      "Type a name or a number and tap the lead.",
      "The lead opens with Avika's score, the answers and the activity.",
      "Use \"Reassign\" or assign a dealer from here."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "no guided walk yet"
    }
  },
  {
    "id": "M20-L06",
    "moduleId": "M20",
    "number": 6,
    "title": "Call the open queue and wrap up the call",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Open queue\" tap \"Start calling\". AURA calls the leads one after another.",
      "After each call the wrap-up opens. Pick \"Reached\" or \"Couldn't reach\".",
      "Fill the answers you got on the call.",
      "Tap \"Verified\", \"Call back\" (pick a time) or \"Reject\" (pick why).",
      "Under \"Assign to rep\" pick a rep and tap \"Assign\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a live call"
    }
  },
  {
    "id": "M20-L07",
    "moduleId": "M20",
    "number": 7,
    "title": "Add a new lead",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Triage\" tap \"Add lead\".",
      "Type \"Mobile number *\" and tap \"Check number\".",
      "If it is already a lead, AURA shows who has it.",
      "Fill \"Name *\", \"Company\", B2C or B2B, \"Products\", State and City, \"Notes\".",
      "Tap \"Save lead\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a lead"
    }
  },
  {
    "id": "M20-L08",
    "moduleId": "M20",
    "number": 8,
    "title": "Work the recovery queue",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "On \"Triage\" tap \"Recovery queue\".",
      "Read \"Attempts\", \"Connected >20s\" and \"Unattended\".",
      "\"Open\" lists leads to verify. \"Recovery\" lists leads you could not reach, with \"attempt n/4\".",
      "Tap a lead to call it, then wrap up the call."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a live call"
    }
  },
  {
    "id": "M20-L09",
    "moduleId": "M20",
    "number": 9,
    "title": "Decide claim requests",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Tap \"Requests\" in the bottom bar.",
      "\"Claim requests\" lists reps who asked for a lead.",
      "Read who asked and why.",
      "Tap \"Approve\" or \"Reject\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "decides a request"
    }
  },
  {
    "id": "M20-L10",
    "moduleId": "M20",
    "number": 10,
    "title": "Your follow-ups",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Open the drawer and tap \"Follow-ups\". It lists the follow-ups you set.",
      "They are grouped \"Overdue\", \"Today\", \"Tomorrow\", \"Later\" and \"Needs scheduling\".",
      "Tap \"+\" (\"Set a follow-up\"), search the lead and pick the date and time.",
      "Tap a follow-up to open its lead."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "saves a follow-up"
    }
  },
  {
    "id": "M20-L11",
    "moduleId": "M20",
    "number": 11,
    "title": "Send a lead to its dealer on WhatsApp and mark it sent",
    "platform": "Android",
    "who": "Lead triage (Triage app)",
    "managerOnly": false,
    "adminOnly": false,
    "hrOnly": false,
    "triageOnly": true,
    "steps": [
      "Open a lead you gave to a dealer. The dealer banner reads \"Not sent\".",
      "Tap \"Send on WhatsApp\". \"Send lead to <dealer>\" opens.",
      "Under \"SEND TO\" pick the dealer's contact, or \"Another number…\".",
      "Read the message: every detail of the lead and what Avika collected. Edit it if needed.",
      "Tap \"Open WhatsApp\". WhatsApp opens with the message; you send it yourself.",
      "Back in AURA answer \"Did you send it?\": tap \"Yes, mark as sent\". The banner reads \"Sent to dealer\" with the time and your name."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "opens WhatsApp"
    }
  }
];

/** Section 5 — a new joiner does these first, in this order. */
export const TOUR_FIRST_DAY: string[] = ["M01-L01","M01-L05","M02-L01","M03-L01","M03-L03","M05-L01","M06-L01","M06-L08","M07-L01","M14-L09","M14-L11","M14-L12","M02-L04"];
/** Section 5 — "Web users also do …" on the first day. */
export const TOUR_FIRST_DAY_WEB: string[] = ["M01-L06","M14-L16","M14-L17"];
/** Section 5 — second day. */
export const TOUR_SECOND_DAY: string[] = ["M04-L01","M04-L05","M06-L02","M06-L03","M06-L07","M08-L01","M09-L01","M01-L07","M01-L08"];
/** Section 6 — a manager does the first-day path, then these. */
export const TOUR_MANAGER_PATH: string[] = ["M10-L01","M16-L01","M16-L02","M16-L03","M16-L05","M16-L06","M16-L07","M16-L08","M16-L11","M16-L13","M11-L06","M16-L04","M17-L01","M17-L06","M17-L07"];
